
import React, { useState, useEffect, useContext, useRef, useMemo } from "react";
import Footer from "../components/dashboard/footer";
import Header from "../components/dashboard/header";
import Sidebar from "../components/dashboard/sidebar";
import SideMenu from "./student/SideMenu";

import { useNavigate, Link } from "react-router-dom";
import { useParams } from 'react-router-dom';
import tmdbApi from "../api/tmdbApi";
import axios from 'axios';
import moment from "moment";
import dayjs from "dayjs";
import { ThemeProvider } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { orangeTheme } from "../components/theme";
import Editor from 'react-simple-wysiwyg';
import Select from 'react-select';
import Loader from "../components/loader";
import Modal from 'react-bootstrap/Modal';

import SweetAlert from 'react-bootstrap-sweetalert';
import { contentContext } from "../context/contentContext";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { v4 as uuid } from 'uuid';
import { Uploader } from "../utils/upload"
import SessionPopup from "./SessionPopup"
import { LazyLoadImage } from "react-lazy-load-image-component";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import "react-lazy-load-image-component/src/effects/blur.css";
import OpenSeadragon from "openseadragon";
import rotateIconorange from "../assets/images/rotate_right-1.svg"

import progessIcon from "../assets/images/gifs/process-icon.gif";
import loadingIcon from "../assets/images/gifs/uploading-icon.gif";
import errorSvg from "../assets/images/gifs/errorSvg.svg";

import doneIcon from "../assets/images/icons/upload-done.png";
import deepZoom from "../assets/images/icons/Dna-dz.svg";
import FileUploadChecker from "../components/FileUploadChecker";
import CreatableSelect from "react-select/creatable";
import rotate_right from '../assets/images/rotate_right.svg';

// Helper to read image dimensions, supporting TIFF


import { fromBlob, fromArrayBuffer } from "geotiff";
import Tooltip from '@mui/material/Tooltip'
import GoogleFormEmbed from "./GoogleFormEmbed";

async function getGeoTiffDimensions(file) {
    let width = 0, height = 0;
    const validTiffExt = [".tif", ".tiff"];
    const validImgExt = [".jpg", ".jpeg", ".png"];

    try {
        if (file instanceof Blob) {
            const name = file.name?.toLowerCase() || "";

            if (validTiffExt.some(ext => name.endsWith(ext))) {
                // --- TIFF / GeoTIFF ---
                const tiff = await fromBlob(file);
                const image = await tiff.getImage(); // first IFD
                width = image.getWidth();
                height = image.getHeight();

            } else if (validImgExt.some(ext => name.endsWith(ext))) {
                // --- JPG / PNG ---
                const img = await blobToImage(file);
                width = img.width;
                height = img.height;

            } else {
                throw new Error("Unsupported file type");
            }

        } else if (typeof file === "string") {
            const lower = file.toLowerCase();

            if (validTiffExt.some(ext => lower.endsWith(ext))) {
                // --- TIFF from URL ---
                const res = await fetch(file);
                if (!res.ok) throw new Error("Failed to fetch TIFF");
                const arrayBuffer = await res.arrayBuffer();
                const tiff = await fromArrayBuffer(arrayBuffer);
                const image = await tiff.getImage();
                width = image.getWidth();
                height = image.getHeight();

            } else if (validImgExt.some(ext => lower.endsWith(ext))) {
                // --- JPG / PNG from URL ---
                const img = await urlToImage(file);
                width = img.width;
                height = img.height;

            } else {
                throw new Error("Unsupported URL type");
            }
        }

        return {
            width,
            height,
            resolution: width * height,
        };
    } catch (err) {
        console.error("Error reading image:", err);
        throw new Error("Could not read image dimensions");
    }
}

// Helpers
function blobToImage(blob) {
    return new Promise((resolve, reject) => {
        const url = URL.createObjectURL(blob);
        const img = new Image();
        img.onload = () => {
            resolve(img);
            URL.revokeObjectURL(url);
        };
        img.onerror = reject;
        img.src = url;
    });
}

function urlToImage(url) {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = "Anonymous"; // may need proper CORS headers
        img.onload = () => resolve(img);
        img.onerror = reject;
        img.src = url;
    });
}







let { lambda, country, appname } = window.app;
const getYouTubeVideoId = (url) => {
    const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
    const match = url?.match(regExp);
    return match && match[7].length === 11 ? match[7] : null;
};
const customComponents = {
    DropdownIndicator: () => null, // Remove the dropdown indicator
    IndicatorSeparator: () => null, // Optionally remove the separator
};

function checkStuckUploads(file) {
    const now = new Date();
    const createdAt = new Date(file.fileCreated);
    const diffInMs = now - createdAt;
    const diffInMinutes = diffInMs / 1000 / 60;
    return file.uploadStatus === "INPROGRESS" && diffInMinutes > 30;
}


const EditTest = () => {
    const transformRef = useRef(null);
    const viewerRef = useRef(null);

    const inputRef = useRef(null);


    let { id } = useParams();
    const navigate = useNavigate();
    const [msg, setMsg] = useState("");
    const [failedData, setFailedData] = useState([]);
    const [FilesData, setFilesData] = useState([]);

    const [isDziProcessing, setIsDziProcessing] = useState(false);

    const [baseUrl, setBaseUrl] = useState("https://qih3mm5tl8.execute-api.ap-south-1.amazonaws.com/prod/")
    const [partsize, setPartsize] = useState(100)
    const [numuploads, setNumuploads] = useState(3)
    const [ta, setTa] = useState(undefined)
    const [pgvalue, setPgvalue] = useState(undefined)
    const [perf, setPerf] = useState(undefined)

    const [diagnosisError, setdiagnosisError] = useState('');
    const [diagnosisIdError, setdiagnosisIdError] = useState('');
    const [youtubeError, setyoutubeError] = useState('');
    const [descriptionError, setdescriptionError] = useState('');
    const [statusError, setstatusError] = useState('');
    const [explanationError, setexplanationError] = useState('');
    const [tagError, settagError] = useState('');
    const [answer1Error, setanswer1Error] = useState('');
    const [answer2Error, setanswer2Error] = useState('');
    const [formData, setFormData] = useState({
        answer: ""
    });
    const [fileDimension, setFileDimension] = useState({})
    const [submitLoading, setSubmitLoading] = useState(false);

    const [caseIdDynamic, setCaseId] = useState(null);
    const [loading, setLoading] = useState(true);
    const [isLoading, setIsLoading] = useState(false);
    const [isUserAdd, setIsUserAdd] = useState(false);
    const [feeError, setFeeError] = useState('');
    const [nameError, setNameError] = useState('');
    const [phoneError, setPhoneError] = useState('');
    const [IdcError, setIdcError] = useState('');
    const [typeError, setTypeError] = useState('');
    const [toastMessage, setToastMessage] = useState(""); // State for dynamic message
    const [managertypeError, setManagerTypeError] = useState('');
    const [editUser, setEditUser] = useState({ diagnosis: '', clinicalhistory: '', diagnosisid: '', youtube: '', tag: '', explanation: '', answer1: '', answer2: '', answer11: '' });
    const [permission, setPermission] = useState({});
    const [completedFiles, setCompletedFiles] = useState([]);

    const [success, setSuccess] = useState(false);
    const [successAnswer, setSuccessAnswer] = useState(false);


    const [errorDisplay, seterrorDisplay] = useState(false);
    const [popup, setShowPopup] = useState(false);
    const [typeSelected, setType] = useState(false);
    const [answerId, setAnswerId] = useState(null);
    const [UpdateSuccess, setUpdateSuccess] = useState(false);
    const [image, setImg] = useState('');
    const [imageCloudfront, setimageCloudfront] = useState('');

    const [manager, setManagers] = useState({});
    const [selectAll, setSelectAll] = useState(false);
    const [showSessionPopupup, setShowSessionPopupup] = useState(false);
    const [existmsg, setExistMsg] = useState(false);
    const [Ismsg, setIsMsg] = useState(false);

    const [imageErrorFiles, setImageErrorFiles] = useState([])
    const [fileSizeError, setFileSizeError] = useState(false);
    const [fileSizeErrorMsg, setFileSizeErrorMsg] = useState("");
    const [inputChange, setInputChange] = useState(true);
    const [questionData, setQuestionData] = useState(null);
    const [imagedisplay, setImageDisplay] = useState(false);
    const [resourceBucket, setResourceImg] = useState(false);

    const [toggleClearRows, setToggleClearRows] = useState(false);
    const [imagesUrls, setImageUrls] = useState(null);
    const [imageFiles, setImageFiles] = useState([])
    const [imageIndex, setImageIndex] = useState(0)
    const [alertPopup, setAlertPopup] = useState(false)
    const [iscaseExisted, setIscaseExist] = useState(false)
    const [errorData, setError] = useState({});


    const [alertPopup2, setAlertPopup2] = useState(false)
    const [deleteImage, setdeleteImage] = useState(false);
    const [deleteImageId, setDeleteImageId] = useState(null);
    const [deleteImageSuccess, setDeleteImageSuccess] = useState(false);
    const [successAPI, setSuccessAPI] = useState(false);
    const [successMsg, setSuccessMsg] = useState("");

    const [uploadImg, setUploadImg] = useState(false);
    const [deleteimageType, setImageType] = useState(null);

    const [selectedFiles, setSelectedFiles] = useState([]);
    const [isSelectMode, setIsSelectMode] = useState(false);
    const [deleteMultipleImages, setDeleteMultipleImages] = useState(false);
    const [deleteMultipleSuccess, setDeleteMultipleSuccess] = useState(false);
    const [isMultiDeleting, setIsMultiDeleting] = useState(false);

    const [clinicalimageFiles, setclinicalImageFiles] = useState([])
    const [clinicalimagesUrls, setClinicalImageUrls] = useState(null);
    const [clinicalimageIndex, setClinicalImageIndex] = useState(0)

    const [uploadedFiles, setUploadedFiles] = useState([])
    const [isLargeImage, setIsLargeImage] = useState(false)

    const [cpcList, setCPCInfo] = useState([])
    const [moduleInfo, setModuleInfo] = useState([]); // all modules from API: [{label, value}]
    // const [ModuleAllData, setModuleAllData] = useState([]); 

    // Deepzoom
    const [isPopupOpen, setPopupOpen] = useState(false);
    const [imageDimensions, setImageDimensions] = useState({ width: 0, height: 0 });
    const [dziUrl, setDziUrl] = useState("");
    const [dziUrlFile, setDziUrlFile] = useState("");

    const [dzipopupImage, setDZIPopupImage] = useState(false);
    const [isPopupLoading, setPopupLoading] = useState(false);
    const [viewer, setViewer] = useState(null);
    const [resetpopup, setresetpopup] = useState(false);
    const [rotation, setRotation] = useState(0);
    const [dziImageList, setDziImageList] = useState([]);
    const [dziCurrentIndex, setDziCurrentIndex] = useState(0);
    const [isDziLoading, setIsDziLoading] = useState(false);
    const [isClinicalLoading, setIsClinicalLoading] = useState(false);




    const [files, setFiles] = useState([]);
    const [tags, setTags] = useState([]);
    const [input, setInput] = useState("");
    const [showVideoPopup, setShowVideoPopup] = useState(false);
    const [showImagePopup, setShowImagePopup] = useState(false);
    const [popupImage, setPopupImage] = useState(null);
    const [clinicalPopupList, setClinicalPopupList] = useState([]);
    const [clinicalPopupIndex, setClinicalPopupIndex] = useState(0);
    const [answers, setAnswersData] = useState(null);
    const [filteredOptionsMap, setFilteredOptionsMap] = useState({});

    const [options, setOptions] = useState([]); // dropdown list (label/value)
    const [selectedTags, setSelectedTags] = useState([]); // [{ label, value }]


    const [checkStatus, setCheckStatus] = useState(false);
    const [invalidContent, setInvalidContent] = useState(false);
    const [histologyPhotoType, setHistologyPhotoType] = useState("");

    const [loadingButton, setLoadingButton] = useState(null);
    // values: "ACTIVE" | "INACTIVE" | null

    const [modulesData, setModulesData] = useState([]);     // raw objects from API
    const [moduleOptions, setModuleOptions] = useState([]); // [{label, value: id}]
    const [selectedModules, setSelectedModules] = useState([]); // [{label, value: id}]
    const [moduleIdList, setModuleIdList] = useState([]);   // ['id1','id2'] -> send to backend

    // Share feature states
    const [showShareModal, setShowShareModal] = useState(false);
    const [shareFile, setShareFile] = useState(null);
    const [shareExpiryAt, setShareExpiryAt] = useState(null);
    const [shareUrl, setShareUrl] = useState('');
    const [shareExpiresAt, setShareExpiresAt] = useState(null);
    const [shareGenerating, setShareGenerating] = useState(false);

    // 1. Add a ref that mirrors the state
    const histologyPhotoTypeRef = useRef("");

    // 2. Whenever you setHistologyPhotoType, also update the ref
    const setHistologyPhotoTypeSafe = (value) => {
        histologyPhotoTypeRef.current = value;
        setHistologyPhotoType(value);
    };
    const { route, setRoute, setCurrentPage, setRowsPerPage, setActiveMenuObj, usePrevious, userData, setActiveMenuId, GetTimeActivity, setIsUploading, setIsUploadingFailed, isRestricted } = useContext(contentContext);
    let isFailed = false;


    const getActualExtension = (filename = "") =>
        "." + filename.split(".").pop().toLowerCase();

    const IMAGE_EXTS = [".jpeg", ".jpg", ".png"];
    const TIFF_EXTS = [".tif", ".tiff"];



    const countFilesByType = (type) => {
        let count = 0;

        // already uploaded (edit mode)
        if (editUser?.files?.length) {
            count += editUser.files.filter(file => {
                const ext = getActualExtension(file.originalFilename || file.filename);
                return type === "histologyJpeg"
                    ? IMAGE_EXTS.includes(ext)
                    : TIFF_EXTS.includes(ext);
            }).length;
        }

        // newly selected (not saved yet)
        if (imageFiles?.length) {
            count += imageFiles.filter(file => {
                const ext = getActualExtension(file.name);
                return type === "histologyJpeg"
                    ? IMAGE_EXTS.includes(ext)
                    : TIFF_EXTS.includes(ext);
            }).length;
        }

        return count;
    };

    // console.log('tags input111,', tags)
    // console.log('tags input222,', input)
    useEffect(() => {

        failedData.length > 0 && failedData.forEach(file => {
            if (checkStuckUploads(file) && !isFailed) {
                // setIsUploadingFailed(true);
                isFailed = true;
                // toast.error(`File ${file.fileid} is stuck in upload. Please re-upload.`);
            }
        });
    }, [failedData])




    const intervalRef = useRef(null);
    // useEffect(() => {
    //     console.log('files data---------------?', FilesData)
    // }, [FilesData])

    useEffect(() => {
        if (!isPopupOpen) return;

        // Disable right-click, drag, copy, and key shortcuts inside viewer
        const blockContext = (e) => e.preventDefault();
        const blockDrag = (e) => e.preventDefault();
        const blockCopy = (e) => e.preventDefault();
        const blockKey = (e) => {
            // Disable F12, Ctrl+Shift+I/J, Ctrl+S, Ctrl+P
            if (
                e.key === "F12" ||
                (e.ctrlKey && e.shiftKey && (e.key === "I" || e.key === "J")) ||
                (e.ctrlKey && (e.key === "s" || e.key === "S" || e.key === "p" || e.key === "P"))
            ) {
                e.preventDefault();
                e.stopPropagation();
            }
        };

        const viewerEl = document.getElementById("openseadragon-viewer");
        if (viewerEl) {
            viewerEl.addEventListener("contextmenu", blockContext);
            viewerEl.addEventListener("dragstart", blockDrag);
            viewerEl.addEventListener("copy", blockCopy);
            viewerEl.addEventListener("keydown", blockKey);
        }

        // Clean up when popup closes
        return () => {
            if (viewerEl) {
                viewerEl.removeEventListener("contextmenu", blockContext);
                viewerEl.removeEventListener("dragstart", blockDrag);
                viewerEl.removeEventListener("copy", blockCopy);
                viewerEl.removeEventListener("keydown", blockKey);
            }
        };
    }, [isPopupOpen]);

    useEffect(() => {
        if (!isPopupOpen || dziImageList.length <= 1) return;
        const handleArrowNav = (e) => {
            if (e.key === "ArrowLeft") {
                e.preventDefault();
                const next = Math.max(0, dziCurrentIndex - 1);
                navigateDziImage(next);
            } else if (e.key === "ArrowRight") {
                e.preventDefault();
                const next = Math.min(dziImageList.length - 1, dziCurrentIndex + 1);
                navigateDziImage(next);
            }
        };
        window.addEventListener("keydown", handleArrowNav);
        return () => window.removeEventListener("keydown", handleArrowNav);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isPopupOpen, dziImageList, dziCurrentIndex, viewer]);

    useEffect(() => {
        if (!showImagePopup || clinicalPopupList.length <= 1) return;
        const handleClinicalArrow = (e) => {
            if (e.key === "ArrowLeft") {
                e.preventDefault();
                navigateClinicalImage(clinicalPopupIndex - 1);
            } else if (e.key === "ArrowRight") {
                e.preventDefault();
                navigateClinicalImage(clinicalPopupIndex + 1);
            }
        };
        window.addEventListener("keydown", handleClinicalArrow);
        return () => window.removeEventListener("keydown", handleClinicalArrow);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [showImagePopup, clinicalPopupList, clinicalPopupIndex]);

    const prevRoute = usePrevious(route)
    useEffect(() => {
        if (prevRoute !== undefined && prevRoute !== route) {
            setCurrentPage(1)
            setRowsPerPage(15)
        }
    }, [prevRoute]);


    useEffect(() => {
        // debugger
        // console.log("imageFiles ,uploadedFiles, ", imageFiles, imageIndex, uploadedFiles)
        if (imageFiles && imageFiles?.length > 0 && uploadedFiles && uploadedFiles?.length > 0) {
            updateFilesAPI()
        }
    }, [uploadedFiles]);


    useEffect(() => {

        if (window.site === undefined) {
            setTimeout(() => {
                if (window.site && window.site.common && window.site.common.imageCloudfront) {
                    const cf = window.site.common.imageCloudfront.replace(/^http:\/\//i, 'https://');
                    setImg(cf)
                    setimageCloudfront(cf)
                    setResourceImg(window.site.common.resourceBucket)
                }
            }, 1000);
        }
        if (window.site && window.site.common && window.site.common.imageCloudfront) {
            console.log('window.site.common', window.site.common)
            const cf = window.site.common.imageCloudfront.replace(/^http:\/\//i, 'https://');
            setImg(cf)
            setimageCloudfront(cf)
            setResourceImg(window.site.common.resourceBucket)
        }


    }, [window.site]);

    useEffect(() => {
        if (toastMessage) {
            toast.success(toastMessage, {
                position: "bottom-center",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });

            // Clear the message after showing to prevent re-triggering
            setToastMessage("");
        }
    }, [toastMessage]);
    const STALE_TTL_MS = 4 * 60 * 60 * 1000; // 4 hours

    function isStaleUpload(file) {
        if (!file) return false;
        if (file.uploadStatus !== "INPROGRESS") return false;
        const lastSeen = new Date(file.lastSeenAt || file.fileCreated || Date.now()).getTime();
        const now = Date.now();
        return (now - lastSeen) > STALE_TTL_MS;
    }

    useEffect(() => {
        if (!localStorage.getItem("token")) {
            navigate("/");
        }
        setActiveMenuId(200005)
        setActiveMenuObj({
            "Client Management": false,
            "Contact Management": false,
            "Reports": false
        })
        setRoute("user")
        // getTags();
        if (id) {
            getLearningCaseInfo();


        }
        // getCpcInfo()
        getModuleInfo()
        GetAnswersInfo()
        // getManagers();
        //  GetCountries();
        // userActivity();
    }, []);


    // const intervalRef = useRef(null);

    // ---- polling helpers & refs ----

    // start polling: call getLearningCaseInfo immediately, then every `intervalMs`
    const startPolling = (intervalMs = 10000) => {
        if (intervalRef.current) return; // already running

        console.log("⏳ Starting polling — pending DZI jobs found...");
        setIsDziProcessing(true); // <-- add here

        const pollDziStatus = async () => {
            try {
                console.log("🔄 Checking dzistatus via getLearningCaseInfo()...");
                await getLearningCaseInfo("k",true); // your existing function - should set FilesData via setFilesData
            } catch (err) {
                console.error("Error while polling getLearningCaseInfo():", err);
            }
            // DO NOT clear interval here. The FilesData effect will stop it when done.
        };

        // call immediately
        pollDziStatus();

        // then schedule repeated calls
        intervalRef.current = setInterval(pollDziStatus, intervalMs);
    };

    // stop polling safely
    const stopPolling = () => {
        if (intervalRef.current) {
            setIsDziProcessing(false); // <-- add here

            clearInterval(intervalRef.current);
            intervalRef.current = null;
            console.log("⏹ Stopped polling.");
        }
    };

    // ---- decide start / stop based on FilesData ----
    // This effect only decides whether to start or stop — it DOES NOT clear intervalRef in cleanup.
    useEffect(() => {
        // Only consider files that explicitly have allow === true
        const allowedFiles = Array.isArray(FilesData) ? FilesData.filter(f => f && f.allow) : [];

        if (allowedFiles.length === 0) {
            // no allowed files => ensure polling stopped
            stopPolling();
            return;
        }

        // If any allowed file is missing dzistatus OR dzistatus !== "COMPLETED" -> pending
        const hasPending = allowedFiles.some(f => !f.dzistatus || String(f.dzistatus).toUpperCase() !== "COMPLETED");

        if (hasPending) {
            // start polling if not already running
            startPolling(10000);
        } else {
            // all allowed files are completed -> stop polling
            stopPolling();
        }

        // NOTE: we intentionally DO NOT return a cleanup that clears the interval here,
        // because clearing on every FilesData change caused early stop in previous code.
    }, [FilesData]); // runs whenever FilesData updates

    // ---- cleanup on unmount only ----
    useEffect(() => {
        return () => {
            stopPolling();
        };
    }, []);


    useEffect(() => {
        const uploads = JSON.parse(localStorage.getItem("uploads") || "[]");
        const now = Date.now();
        const THRESHOLD = 5 * 60 * 1000; // 5 minutes

        // Find all unfinished uploads older than threshold
        const unfinished = uploads.filter(
            (f) =>
                f.uploadStatus === "INPROGRESS" &&
                now - f.timestamp > THRESHOLD
        );

        if (unfinished.length > 0) {
            // alert(
            //     `These files failed to upload: ${unfinished
            //         .map((f) => f.fileName)
            //         .join(", ")}`
            // );
            setIsUploadingFailed(true)
            setTimeout(function () {
                setIsUploadingFailed(false);

            }, 2000)
            setIsUploading(false)

            // Mark them as FAILED in localStorage
            const updatedUploads = uploads.map((f) => {
                if (
                    f.uploadStatus === "INPROGRESS" &&
                    now - f.timestamp > THRESHOLD
                ) {
                    return { ...f, uploadStatus: "FAILED" };
                }
                return f;
            });

            localStorage.setItem("uploads", JSON.stringify(updatedUploads));
        }
    }, []);
    const createAnswer = async (formData) => {
        try {
            let response;
            // if (typeSelected == "Add") {
            response = await tmdbApi.AddAnswer(formData);
            // } else {
            //     response = await tmdbApi.UpdateAnswer(formData, answerId);
            // }
            if (response?.result === "Invalid token or Expired") {
                setShowSessionPopupup(true)
                // localStorage.clear();
                // navigate("/")
            } else if (response?.result === "Answer already exists") {
                setError((prevData) => ({
                    ...prevData, // Keep the other fields intact
                    ["answer"]: "This answer already exists", // Update the changed field
                }));
                seterrorDisplay(true)
                setTimeout(function () { seterrorDisplay(false) }, 3000);
            }
            else {
                setSuccessAnswer(true);
            }
            console.log(response);
            // if (response?.statusCode == 200) {

            //  }
        } catch {
            console.log("error");
        }
    };
    const handleClosePopup = () => {
        setFormData((prevData) => ({
            ...prevData, // Keep the other fields intact
            "answer": "", // Update the changed field
        }));
        setShowPopup(false);
        setAnswerId(null)
    }


    function formvalidationAnswer() {
        GetTimeActivity()
        let formIsValid = true;

        if (formData?.answer == "") {
            setError((prevData) => ({
                ...prevData, // Keep the other fields intact
                ["answer"]: "Please enter Answer", // Update the changed field
            }));
            seterrorDisplay(true)
            setTimeout(function () { seterrorDisplay(false) }, 3000);
            formIsValid = false;
        } else {
            setError((prevData) => ({
                ...prevData, // Keep the other fields intact
                ["answer"]: "", // Update the changed field
            }));
        }

        return formIsValid;
    }
    const handleChangeAnswer = (event) => {
        const { name, value } = event.target;
        setFormData((prevData) => ({
            ...prevData, // Keep the other fields intact
            [name]: value, // Update the changed field
        }));
    };
    const handleSubmitAnswer = async (e) => {
        // Prevent the function from running if already loading
        if (submitLoading) return;

        setSubmitLoading(true);
        GetTimeActivity();

        try {
            const isValid = formvalidationAnswer();
            if (isValid) {
                await createAnswer(formData); // Wait for this to complete
            }
        } catch (error) {
            console.log("Error in handleSubmit:", error);
        } finally {
            setSubmitLoading(false); // This will run after createAnswer completes
        }
    };
    const GetAnswersInfo = async () => {
        try {
            const response = await tmdbApi.answerInfo();
            console.log('respponse answer info', response)
            if (response?.result === "Invalid token or Expired") {
                setShowSessionPopupup(true)
            }
            if (typeof response?.result === 'object') {
                let ans = response?.result?.answerData || [];
                if (ans.length > 0) {
                    let tmpArr = [];
                    ans.forEach(a => {
                        let obj = {
                            value: `${a.answerid}`,
                            label: a.answer
                        }
                        tmpArr.push(obj)
                    })
                    setAnswersData(tmpArr);

                    setFilteredOptionsMap({
                        answer1: tmpArr,
                        answer11: tmpArr,
                        answer2: tmpArr
                    })


                }

            }
            setLoading(false);
        } catch {
            console.log("error");
        }
    };


    useEffect(() => {
        //  debugger
        if (!viewerRef.current) return;

        console.log("[OSD useEffect] dziUrl:", dziUrl);
        console.log("[OSD useEffect] imageDimensions:", imageDimensions);
        console.log("[OSD useEffect] viewerRef.current:", viewerRef.current);
        const isDziURL = dziUrl.includes("output.dzi");
        console.log("[OSD useEffect] isDziURL:", isDziURL);
        const { width, height } = imageDimensions;

        const tileSource = isDziURL
            ? {
                Image: {
                    xmlns: "http://schemas.microsoft.com/deepzoom/2008",
                    Url: encodeURI(dziUrl),
                    Format: "jpeg",
                    Overlap: 2,
                    TileSize: 256,
                    Size: { Width: width, Height: height },
                },
            }
            : {
                type: "image",
                url: encodeURI(dziUrl),
                buildPyramid: false,
            };
        console.log("[OSD useEffect] tileSource:", tileSource);

        const osdViewer = OpenSeadragon({
            id: "openseadragon-viewer",
            prefixUrl: "https://openseadragon.github.io/openseadragon/images/",
            tileSources: tileSource,
            showNavigator: true,
            crossOriginPolicy: "Anonymous",
            navigatorPosition: "BOTTOM_RIGHT",
            maxZoomPixelRatio: 10,
            minZoomImageRatio: 0.5,
            visibilityRatio: 1,
            zoomPerScroll: 2,
            homeFillsViewer: true,
            gestureSettingsMouse: {
                clickToZoom: true,
                dblClickToZoom: true,
                flickEnabled: true,
                pinchToZoom: true,
                scrollToZoom: true,
            },
            showZoomControl: true,
            showHomeControl: true,
            showFullPageControl: true,
            showRotationControl: true,
            wrapHorizontal: false,
        });


        setViewer(osdViewer);

        return () => {
            if (osdViewer) {
                osdViewer.destroy();
            }
        };
    }, [dziUrl, imageDimensions]);
    const rotateImage = (angle) => {
        if (viewer) {
            const newRotation = (rotation + angle) % 360;
            viewer.viewport.setRotation(newRotation);
            setRotation(newRotation);
        }
    };

    const resetZoom = () => {
        if (viewer) {
            viewer.viewport.goHome();
            viewer.viewport.setRotation(0);
            setRotation(0);
        }
    };

    const closeDeepZoom = () => {
        setPopupOpen(false);
        setDziUrl("");
        setDziUrlFile("");
        setImageDimensions({ width: 0, height: 0 });
        setDziImageList([]);
        setDziCurrentIndex(0);
        if (viewer) {
            viewer.destroy();
            setViewer(null);
        }
    };

    const getDziPendingHours = (file) => {
        if (!file?.fileCreated) return null;
        return Math.floor((Date.now() - new Date(file.fileCreated).getTime()) / 3600000);
    };

    const isDziStuck = (file) => {
        if (file?.uploadStatus !== "COMPLETED") return false;
        if (file?.dzistatus === "COMPLETED") return false;
        const hours = getDziPendingHours(file);
        return hours !== null && hours > 6;
    };

    const buildTileSourceForFile = (file) => {
        let path = file.dziUrl || "";
        if (path.startsWith("/")) path = path.slice(1);
        const isDziURL = path.includes("output.dzi");
        if (isDziURL) {
            path = `${path}_files/`;
            return {
                Image: {
                    xmlns: "http://schemas.microsoft.com/deepzoom/2008",
                    Url: encodeURI(imageCloudfront + path),
                    Format: "jpeg",
                    Overlap: 2,
                    TileSize: 256,
                    Size: { Width: file.width, Height: file.height },
                },
            };
        }
        const url = encodeURI(`${imageCloudfront}${(file.sourcepath || "").replace(/ /g, "%20")}?auto=compress,format`);
        return { type: "image", url, buildPyramid: false };
    };

    const navigateDziImage = (newIndex) => {
        if (!dziImageList.length) return;
        const clamped = Math.max(0, Math.min(newIndex, dziImageList.length - 1));
        const file = dziImageList[clamped];
        if (!file) return;
        const tileSource = buildTileSourceForFile(file);
        if (viewer) {
            setIsDziLoading(true);
            viewer.open(tileSource);
            viewer.viewport.setRotation(0);
            viewer.addOnceHandler("open", () => setIsDziLoading(false));
        }
        setDziCurrentIndex(clamped);
        setDziUrlFile(file?.originalFilename ? file?.originalFilename : file.filename);
        // Do NOT call setImageDimensions here — it would re-trigger the OSD useEffect
        // and recreate the viewer with the stale dziUrl, overwriting viewer.open().
        setDZIPopupImage(imageCloudfront + file.sourcepath);
        setRotation(0);
    };

    const getModuleId = (m) => {
        // adjust keys if your API uses a different id field
        return String(m.moduleid ?? m.id ?? m._id ?? "");
    };
    const getModuleInfo = async () => {
        try {
            const response = await tmdbApi.getmoduleInfo("ACTIVE");
            const data = response?.result?.data ?? [];
            setModulesData(data);

            const options = data.map((tag) => ({
                label: tag.name,
                value: getModuleId(tag),
            }));
            setModuleOptions(options);
        } catch (err) {
            console.error("getModuleInfo failed", err);
            setModulesData([]);
            setModuleOptions([]);
        }
    };

    // --- initialize selectedModules from editUser.caseModules ---
    // editUser.caseModules might contain names or ids depending on backend.
    // We'll try matching by id first, then by name.
    useEffect(() => {
        const assigned = Array.isArray(editUser?.caseModules)
            ? editUser.caseModules
            : [];

        if (assigned.length === 0) {
            setSelectedModules([]);
            setModuleIdList([]);
            return;
        }

        // ensure modulesData is available; if not, we still create fallback items
        const selected = assigned.map((val) => {
            // try match by id
            const byId = modulesData.find(
                (m) => getModuleId(m) === String(val)
            );
            if (byId) {
                return { label: byId.name, value: getModuleId(byId) };
            }

            // try match by name
            const byName = modulesData.find((m) => m.name === val);
            if (byName) {
                return { label: byName.name, value: getModuleId(byName) };
            }

            // fallback: value is unknown (maybe stale); keep it so it's shown as chip
            return { label: String(val), value: String(val), missing: true };
        });

        setSelectedModules(selected);

        // compute list of ids (exclude missing ones if they don't map to real id)
        const ids = selected
            .filter((s) => !s.missing)
            .map((s) => String(s.value));
        setModuleIdList(ids);
    }, [editUser?.caseModules, modulesData]);

    // --- whenever user changes the selection in UI, keep moduleIdList updated ---
    const handleChangeModules = (newValue) => {
        const arr = newValue || []; // [{label, value}, ...]
        setSelectedModules(arr);

        // moduleIdList: include only values that look like real IDs (you can adjust filter)
        const ids = arr.map((s) => String(s.value));
        setModuleIdList(ids);
    };

    // --- compute dropdown options = master list - currently selected ids ---
    useEffect(() => {
        const selectedSet = new Set(selectedModules.map((s) => String(s.value)));
        const remaining = modulesData
            .filter((m) => !selectedSet.has(getModuleId(m)))
            .map((m) => ({ label: m.name, value: getModuleId(m) }));

        setModuleOptions(remaining);
    }, [modulesData, selectedModules]);

    // console.log('modulesData---------->', modulesData)
    // console.log('moduleOptions---------->', moduleOptions)
    // console.log('selectedModules---------->', selectedModules)
    // console.log('moduleIdList---------->', moduleIdList)
    const getCpcInfo = async () => {
        const response = await tmdbApi.cpcInfo("ACTIVE,UPCOMING");

        if (response?.result?.length > 0) {
            setCPCInfo(response?.result)
        }
    }

    const userActivity = () => {
        let path = window.location.pathname.split("/");
        const pageName = id !== undefined ? path[path.length - 2] : path[path.length - 1];;
        var presentTime = moment();
        let payload;

        payload = {
            "userid": localStorage.getItem("userId"),
            "pagename": pageName,
            "pageurl": window.location.href,
            "starttime": presentTime,
            "useragent": JSON.parse(localStorage.getItem("loc"))

        };


        const previousId = localStorage.getItem("previousid");
        const urlLink = lambda + '/useractivity?appname=' + appname + (previousId ? "&previousid=" + previousId : "");


        axios({
            method: 'POST',
            url: urlLink,
            data: payload
        })
            .then(function (response) {
                if (response?.data?.statusCode === 200) {
                    localStorage.setItem("previousid", response?.data?.result)
                }
            });
    }


    // const getTags = (e) => {
    //     GetTimeActivity()
    //     const userId = localStorage.getItem("userId")
    //     const token = localStorage.getItem("token")
    //     axios({
    //         method: 'GET',
    //         url: lambda + '/tagInfo?appname=' + appname,
    //         // + '&userid=' + userId ,

    //         // + '&token=' + token,
    //     })
    //         .then(function (response) {
    //             console.log("response tagsssssssssssss", response?.data?.result);

    //             const list = response?.data?.result?.map((tag) => ({
    //                 label: tag.name,
    //                 value: tag.name,
    //             }));
    //             setOptions(list);


    //         });
    // }
    // useEffect(() => {

    //     setSelectedTags(tags.map((t) => ({ label: t, value: t })));

    // }, [tags])

    // const handleChangeTags = (newValue) => {
    //     setSelectedTags(newValue || []);
    //     const tagNames = (newValue || []).map((item) => item.value);
    //     setTags(tagNames); // update state as array of strings
    // };

    const getLearningCaseInfo = (e,timer=null) => {
        try {
            if (!timer) setLoading(true);


            GetTimeActivity()
            const userId = localStorage.getItem("userId")
            const token = localStorage.getItem("token")
            axios({
                method: 'POST',
                url: lambda + '/learningCaseInfo?appname=' + appname + '&userid=' + userId + '&caseid=' + id + '&token=' + token,
            })
                .then(function (response) {
                    //  console.log("response", response?.data?.result?.[0]);
                    if (response?.data?.result === "Invalid token or Expired") {
                        setShowSessionPopupup(true)
                        // localStorage.clear();
                        // navigate("/")
                    }
                    else {
                        if (response?.data?.result?.questionData?.length > 0) {
                            // setImageUrls([])
                            
                            if (timer) {
                                const res = response?.data?.result?.questionData?.[0]

                                setEditUser((prev) => ({
                                    ...prev, // keep edited form fields
                                    files: res.files, // update only files
                                    historyFiles: res.historyFiles, // if needed
                                }));
                            } else {
                                setEditUser(response?.data?.result?.questionData?.[0]);
                            }
                           
                            // console.log(response?.data?.result, "ccssd s");
                            if (response?.data?.result?.questionData?.[0]?.files && response?.data?.result?.questionData?.[0]?.files?.length > 0) {
                                let completedFiles = response?.data?.result?.questionData?.[0]?.files.filter(file => file.dzistatus === "COMPLETED") || [];
                                setCompletedFiles(completedFiles)
                            }

                            const filesData = response?.data?.result?.questionData?.[0]?.files || [];
                            setFailedData(filesData)
                            setFilesData(filesData)
                            console.log('filesDatafilesDatafilesDatafilesData', filesData)
                            setHistologyPhotoTypeSafe(determinePhotoTypeFromAllFiles([], filesData));
                            console.log('check type', determinePhotoTypeFromAllFiles([], filesData))
                            // setHistologyPhotoType(response?.data?.result?.questionData?.[0]?.histologyPhotoType || "")
                            // setTags(response?.data?.result?.questionData?.[0]?.tags || [])
                            if (response?.data?.result?.questionData?.[0] && response?.data?.result?.questionData?.[0]?.permissions) {
                                setPermission(response?.data?.result?.questionData?.[0]?.permissions)
                            }
                        } else {
                            setInvalidContent(true)
                        }
                    }
                    // getPermissions(response?.data && response?.data?.result && response?.data?.result?.[0] && response?.data?.result?.[0]?.type)
                    setLoading(false);
                });
        } catch (error) {
            console.error(error);
            setLoading(false);
        }
    }


    console.log('loading ', loading)
    const handleImageErrorDelete = (e, key) => {
        setImageErrorFiles(imageErrorFiles.filter(item => item.name !== key?.name));

    }
    console.log('histology photo type', histologyPhotoType)

    const onclickInvalid = () => {
        GetTimeActivity()
        setInvalidContent(false)
        navigate('/')
    }

    const onDescriptionChange = (e) => {
        setEditUser((prevData) => ({
            ...prevData,
            clinicalhistory: e.target.value // Update the 'description' field with Quill editor value
        }));
        setInputChange(false)
    };

    const onExplanationChange = (e) => {
        setEditUser((prevData) => ({
            ...prevData,
            explanation: e.target.value // Update the 'description' field with Quill editor value
        }));
        setInputChange(false)
    };

    const handleImageDelete = (e, key) => {
        let imgUrls = { ...imagesUrls }
        let imgIndex = imageIndex
        // console.log('imgIndex ', imgIndex)
        // console.log('imgIndex ', imgUrls[key]?.name)

        // let targetIndex = imageFiles.findIndex((each) => {each.name == imgUrls[key]?.name});
        // imageFiles.splice(targetIndex-1, 1);
        setImageFiles(imageFiles.filter(item => item.name !== imgUrls[key]?.name));

        // setImageFiles((imageFiles) => {
        //     return [
        //         ...imageFiles.filter((item, i) => item.name != imgUrls[key]?.name)
        //     ]
        // })

        if (imgUrls[key]) {
            delete imgUrls[key]
        }
        setImageUrls(imgUrls)
        setImageIndex(imgIndex - 1)

    }

    const handleImageFileDelete = async (e, item, key, type) => {
        console.log("item ", item)
        setdeleteImage(true)
        let obj = item
        obj["index"] = key
        setDeleteImageId(item)
        setImageType(type)
    }

    const handleShareClick = (file) => {
        console.log("[Share] Share button clicked for file:", { fileid: file?.fileid, filename: file?.originalFilename || file?.filename, sourcepath: file?.sourcepath, dzistatus: file?.dzistatus });
        setShareFile(file);
        setShareExpiryAt(dayjs().add(1, 'hour'));
        setShareUrl('');
        setShareExpiresAt(null);
        setShowShareModal(true);
    };

    const isShareExpiryValid = shareExpiryAt && shareExpiryAt.isValid() && shareExpiryAt.diff(dayjs(), 'minute') >= 1;

    const getShareExpiryCountdown = () => {
        if (!isShareExpiryValid) return '';
        const mins = shareExpiryAt.diff(dayjs(), 'minute');
        const days = Math.floor(mins / 1440);
        const hrs = Math.floor((mins % 1440) / 60);
        const rem = mins % 60;
        if (days > 0) return `${days} day${days !== 1 ? 's' : ''}${hrs > 0 ? ` ${hrs} hr` : ''} from now`;
        if (hrs > 0) return `${hrs} hr${rem > 0 ? ` ${rem} min` : ''} from now`;
        return `${rem} min from now`;
    };

    const handleGenerateShareUrl = async () => {
        if (!shareExpiryAt || !shareExpiryAt.isValid() || shareExpiryAt.diff(dayjs(), 'minute') < 1) {
            toast.error("Please select a valid future date and time.", {
                position: "bottom-center", autoClose: 2000, hideProgressBar: false,
                closeOnClick: true, pauseOnHover: true, draggable: true, theme: "light",
            });
            return;
        }
        // Backend accepts whole hours — round up so the link never expires before the selected time.
        const hours = Math.max(1, Math.ceil(shareExpiryAt.diff(dayjs(), 'minute') / 60));
        console.log("[Share] Generating share URL — caseid:", id, "fileid:", shareFile?.fileid, "expiresAt:", shareExpiryAt.format(), "hours:", hours, "sourcepath:", shareFile?.sourcepath);
        setShareGenerating(true);
        try {
            const payload = { fileid: shareFile?.fileid, sourcepath: shareFile?.sourcepath, dziUrl: shareFile?.dziUrl, width: shareFile?.width, height: shareFile?.height, hours };
            console.log("[Share] generateShareUrl payload:", payload);
            const response = await tmdbApi.generateShareUrl(id, payload);
            console.log("[Share] generateShareUrl response:", response);
            if (response?.data?.result === "Invalid token or Expired") {
                setShowSessionPopupup(true);
                setShowShareModal(false);
                return;
            }
            const shareId = response?.result;

            if (!shareId) {
                console.error("[Share] No shareId returned in response.");
                toast.error("Failed to generate share link. Please try again.", {
                    position: "bottom-center", autoClose: 2000, hideProgressBar: false,
                    closeOnClick: true, pauseOnHover: true, draggable: true, theme: "light",
                });
                return;
            }
            const generatedUrl = `${window.location.origin}/shared-view/${shareId}`;
            console.log("[Share] Share URL generated:", generatedUrl, "expiresAt:", response?.data?.result?.expiresAt);
            setShareUrl(generatedUrl);
            setShareExpiresAt(response?.data?.result?.expiresAt || null);
            toast.success("Share link generated successfully!", {
                position: "bottom-center", autoClose: 2000, hideProgressBar: false,
                closeOnClick: true, pauseOnHover: true, draggable: true, theme: "light",
            });
        } catch (err) {
            console.error("[Share] generateShareUrl error:", err?.message || err, err?.response?.data);
            toast.error("Failed to generate share link. Please try again.", {
                position: "bottom-center", autoClose: 2000, hideProgressBar: false,
                closeOnClick: true, pauseOnHover: true, draggable: true, theme: "light",
            });
        } finally {
            setShareGenerating(false);
        }
    };

    const handleCopyShareUrl = () => {
        navigator.clipboard.writeText(shareUrl).then(() => {
            toast.success("Link copied to clipboard!", {
                position: "bottom-center", autoClose: 2000, hideProgressBar: false,
                closeOnClick: true, pauseOnHover: true, draggable: true, theme: "light",
            });
        }).catch(() => {
            toast.error("Failed to copy link.", {
                position: "bottom-center", autoClose: 2000, hideProgressBar: false,
                closeOnClick: true, pauseOnHover: true, draggable: true, theme: "light",
            });
        });
    };

    const handleWhatsAppShare = () => {
        const text = encodeURIComponent(`View this histology image: ${shareUrl}`);
        window.open(`https://wa.me/?text=${text}`, '_blank');
    };

    // const handleFileChange = async (event) => {
    //     const selectedFiles = Array.from(event.target.files);
    //     setInputChange(false)
    //     let filesLength = 0
    //     if (editUser && editUser?.files?.length > 0) {
    //         filesLength = filesLength + editUser?.files.length
    //     }
    //     if (imageFiles && imageFiles?.length > 0) {
    //         filesLength = filesLength + imageFiles?.length
    //     }
    //     if (selectedFiles && selectedFiles?.length > 0) {
    //         filesLength = filesLength + selectedFiles?.length
    //     }


    //     if (filesLength > 10) {
    //         setAlertPopup(true)
    //         return;
    //     }
    //     //for multiple files
    //     setImageDisplay(true)
    //     // setImageFiles(selectedFiles)
    //     // setImageFiles((prevData) => ([
    //     //     ...prevData, // Keep the other fields intact
    //     //     selectedFiles
    //     // ]));

    //     Array.from(selectedFiles).map(async (file, index) => {
    //         console.log('file', file)
    //         // console.log('setImageIndex ', imageIndex, index)
    //         let fileSize = 1048612 * 20 // 5MB
    //         // if (file?.size < fileSize) {
    //         if (imageIndex > 0) {
    //             index = index + imageIndex
    //         }
    //         let urlobj = URL.createObjectURL(file)
    //         // let img = new Image();
    //         // img.onload = function () {
    //         // alert(this.width + " " + this.height);
    //         // if (this.width < 3841) {
    //         // if (this.width < 2000) {


    //         setImageFiles((prevData) => ([
    //             ...prevData, // Keep the other fields intact
    //             file
    //         ]));

    //         setImageUrls((prevData) => ({
    //             ...prevData, // Keep the other fields intact
    //             ["blob" + index]: {
    //                 url: urlobj,
    //                 name: file?.name
    //             }, // Update the changed field
    //         }));
    //         setImageIndex(index + 1)
    //         // } else {
    //         //     setFileSizeError(true)
    //         //     setFileSizeErrorMsg("Resolution has been greater than 3840px and 2160px")
    //         //     // let obj = {
    //         //     //     name: file?.name,
    //         //     //     size: file?.size,
    //         //     //     width: this.width,
    //         //     //     height: this.height,
    //         //     //     error: "Resolution has been greater then 3840px and 2160px",
    //         //     //     url: urlobj
    //         //     // }
    //         //     // setImageErrorFiles((prevData) => ([
    //         //     //     ...prevData, // Keep the other fields intact
    //         //     //     obj
    //         //     // ]));
    //         // }
    //         // };
    //         //  img.src = urlobj;
    //         // } else {
    //         //     setFileSizeError(true)
    //         //     setFileSizeErrorMsg("File size greater than 20MB")
    //         // }


    //     })

    // };

    // const handleClinicalImageDelete = (e, key) => {
    //     let imgUrls = { ...clinicalimagesUrls }
    //     let imgIndex = clinicalimageIndex

    //     setclinicalImageFiles(clinicalimageFiles.filter(item => item.name !== imgUrls[key]?.name));
    //     if (imgUrls[key]) {
    //         delete imgUrls[key]
    //     }
    //     setClinicalImageUrls(imgUrls)
    //     setClinicalImageIndex(imgIndex - 1)

    // }
    const imageExtensions = ['.tif', '.tiff', '.jpeg', '.jpg', '.png'];
    const MAX_PIXELS = 10000000000;
    const handleFileChange = async (event, typeofFile) => {
        try {
            const input = event.target;
            const selectedFiles = Array.from(input.files);
            selectedFiles.filter(file => {
                const ext = file.name.toLowerCase().substring(file.name.lastIndexOf('.'));
                if (!imageExtensions.includes(ext)) {
                    // Optionally show a message that non-image files are rejected
                    setFileSizeError(true);
                    setFileSizeErrorMsg(`File type "${ext}" is not supported.`);
                    return false;
                }
            });


            const currentCount = countFilesByType(typeofFile);
            const incomingCount = selectedFiles.length;

            if (typeofFile === "histologyJpeg") {
                if (currentCount + incomingCount > 20) {
                    setAlertPopup2(true);
                    input.value = "";
                    return;
                }
            }

            if (typeofFile === "histologyTiff") {
                if (currentCount + incomingCount > 10) {
                    setAlertPopup(true);
                    input.value = "";
                    return;
                }
            }




            setInputChange(false);

            let filesLength = 0;
            if (editUser && editUser?.files?.length > 0) {
                filesLength += editUser.files.length;
            }
            if (imageFiles && imageFiles?.length > 0) {
                filesLength += imageFiles.length;
            }
            if (selectedFiles && selectedFiles.length > 0) {
                filesLength += selectedFiles.length;
            }

            // if (typeofFile === "histologyJpeg") {
            //     if (filesLength > 20) {
            //         setAlertPopup2(true);
            //         return;
            //     }
            // } else if (typeofFile === "histologyTiff") {
            //     if (filesLength > 10) {
            //         setAlertPopup(true);
            //         return;
            //     }
            // }


            setImageDisplay(true);

            // const MAX_FILE_SIZE = 2 * 1024 * 1024 * 1024; // 2GB

            for (let index = 0; index < selectedFiles.length; index++) {
                const file = selectedFiles[index];
                let dimensions = { width: null, height: null, resolution: null };
                try {
                    dimensions = await getGeoTiffDimensions(file)
                    // debugger
                    let msg = "";

                    let tnpDim = { ...fileDimension }
                    tnpDim[file.name] = dimensions

                    setFileDimension(tnpDim)
                    if ((dimensions.width * dimensions.height) > MAX_PIXELS) {
                        msg += `Resolution (width × height) of "${file.name}" exceeds the maximum allowed 10,000,000,000 pixels. `;
                    }
                    if (msg !== "") {
                        setFileSizeError(true);
                        setFileSizeErrorMsg(msg);
                        continue; // Skip this file and continue with next
                    }
                    input.value = "";
                } catch (e) {
                    console.log(e.message);
                }
            }

            for (let index = 0; index < selectedFiles.length; index++) {
                const file = selectedFiles[index];


                let adjustedIndex = index;
                if (imageIndex > 0) {
                    adjustedIndex = index + imageIndex;
                }

                const urlobj = URL.createObjectURL(file);

                setImageFiles((prevData) => [...prevData, file]);

                setImageUrls((prevData) => ({
                    ...prevData,
                    ["blob" + adjustedIndex]: {
                        url: urlobj,
                        name: file.name,
                    },
                }));

                setImageIndex(adjustedIndex + 1);
            }
        } catch (err) {
            console.log(err, "err")
        }
    };


    const handleClinicalImageDelete = (e, key) => {
        // remove from urls
        setClinicalImageUrls((prev) => {
            const updated = { ...prev };
            if (updated[key]) {
                delete updated[key];
            }
            console.log("After delete clinicalImageUrls:", updated);
            return updated;
        });

        // remove from files by id
        setclinicalImageFiles((prev) => {
            const updated = prev.filter((f) => f.id !== key);
            console.log("After delete clinicalImageFiles:", updated);
            return updated;
        });
    };



    //      const handleimageFileChange = async (event) => {

    //         const selectedFiles = Array.from(event.target.files);
    //         // console.log('ques', questionData?.files.length, imageFiles?.length, selectedFiles?.length)
    //         setInputChange(false)
    // let clinicalCount = 0;
    //   if (clinicalimageFiles?.length > 0) clinicalCount += clinicalimageFiles.length;
    //   if (imageFiles?.length > 0) clinicalCount += imageFiles.length;
    //   if (selectedFiles?.length > 0) clinicalCount += selectedFiles.length;

    //   if (clinicalCount > 10) {
    //     setAlertPopup(true);
    //     event.target.value = null;
    //     return;
    //   }


    //   const historyFilesLength = editUser?.historyfiles?.length || 0;
    //   const totalCount = historyFilesLength + clinicalCount;

    //   if (totalCount > 10) {
    //     setAlertPopup(true);
    //     event.target.value = null;
    //     return;
    //   }  
    //     Array.from(selectedFiles).map(async (file, index) => {
    //             // File size enable
    //             let fileSize = 1048612 * 20 // 20MB
    //             if (file?.size < fileSize) {
    //                 if (clinicalimageIndex > 0) {
    //                     index = index + clinicalimageIndex
    //                 }
    //                 console.log("index", index)
    //                 let urlobj = URL.createObjectURL(file)
    //                 let img = new Image();
    //                 img.onload = function () {
    //                     setclinicalImageFiles((prevData) => ([
    //                         ...prevData, // Keep the other fields intact
    //                         file
    //                     ]));

    //                     setClinicalImageUrls((prevData) => ({
    //                         ...prevData, // Keep the other fields intact
    //                         ["blob" + index]: {
    //                             url: urlobj,
    //                             name: file?.name
    //                         }, // Update the changed field
    //                     }));
    //                     setClinicalImageIndex(index + 1)
    //                 };
    //                 img.src = urlobj;
    //             } else {
    //                 setFileSizeError(true)
    //                 setFileSizeErrorMsg("File size greater than 20MB")
    //             }


    //         })

    //     };

    const handleimageFileChange = async (event) => {
        const selectedFiles = Array.from(event.target.files);
        setInputChange(false);

        let clinicalCount = 0;
        if (clinicalimageFiles?.length > 0) clinicalCount += clinicalimageFiles.length;
        if (imageFiles?.length > 0) clinicalCount += imageFiles.length;
        if (selectedFiles?.length > 0) clinicalCount += selectedFiles.length;

        if (clinicalCount > 10) {
            setAlertPopup(true);
            event.target.value = null;
            // input.value = null;
            return;
        }

        const historyFilesLength = editUser?.historyfiles?.length || 0;
        const totalCount = historyFilesLength + clinicalCount;

        if (totalCount > 10) {
            setAlertPopup(true);
            event.target.value = null;
            // input.value = null;
            return;
        }

        selectedFiles.forEach((file) => {
            let fileSize = 1048612 * 20; // 20MB
            if (file?.size < fileSize) {
                let urlobj = URL.createObjectURL(file);
                let img = new Image();
                img.onload = function () {

                    const uniqueKey = `${file.name}-${Date.now()}-${Math.random()}`;


                    setclinicalImageFiles((prevData) => {
                        const updated = [...prevData, { id: uniqueKey, file }];
                        console.log("Updated clinicalimageFiles:", updated);
                        return updated;
                    });


                    setClinicalImageUrls((prevData) => {
                        const updated = {
                            ...prevData,
                            [uniqueKey]: {
                                url: urlobj,
                                name: file?.name,
                                id: uniqueKey,
                            },
                        };
                        console.log("Updated clinicalImageUrls:", updated);
                        return updated;
                    });
                };
                img.src = urlobj;
            } else {
                setFileSizeError(true);
                setFileSizeErrorMsg("File size greater than 20MB");
            }
        });
    };

    // const handleKeyDown = (e) => {
    //     if ((e.key === "Enter" || e.key === ",") && input.trim()) {
    //         e.preventDefault();
    //         const newTag = input.trim();
    //         if (tags && !tags.includes(newTag)) {
    //             setTags([...tags, newTag]);
    //         }
    //         setInput("");
    //     }
    //     if (e.key === "Backspace" && input === "" && tags.length > 0) {
    //         e.preventDefault();
    //         const updatedTags = [...tags];
    //         const lastTag = updatedTags.pop();
    //         setTags(updatedTags);
    //         setInput(lastTag);
    //     }
    // };

    // const removeTag = (indexToRemove) => {
    //     setTags(tags.filter((_, index) => index !== indexToRemove));
    // };



    const handleClickContainer = () => {
        inputRef.current.focus();
    };




    const handleFileUpload = async (clinicalimageFiles, caseid) => {
        if (clinicalimageFiles && clinicalimageFiles.length > 0) {
            let filesArray = [];

            const uploadPromises = clinicalimageFiles.map(async (fileObj) => {
                const file = fileObj.file;
                const timestamp = Date.now();
                const fileExtension = file?.name?.split('.').pop();
                const ObjectID = require("bson-objectid");
                const uniqueId = new ObjectID().toString();
                let uploadFilePath;
                let bucket;

                if (file.type.startsWith("image/")) {
                    let filenameReplace = file.name.replace(/ /g, "_");
                    const fileNameUnique = `${uniqueId}_image_${timestamp}.${fileExtension}`;
                    uploadFilePath = `${appname}/cases/clinicalhistory/${caseid}/${fileNameUnique}`;
                    bucket = window.site?.common?.resourceBucket;


                    const data = {
                        source_bucket: bucket,
                        sourcepath: uploadFilePath,
                        filename: fileNameUnique,
                    };

                    const newFile = {
                        filename: filenameReplace.split(".")[0],
                        sourcepath: uploadFilePath,
                        fileid: uniqueId,
                        filetype: file.type,
                        filesize: file.size,
                        fileformat: fileExtension
                    };

                    filesArray.push(newFile);
                    setFiles((files) => [...files, newFile]);

                    try {
                        // Get Upload URL
                        const uploadUrlResponse = await axios.post(
                            `${lambda}/uploadFiles?appname=${appname}&caseid=${caseid}`,
                            data,
                            { headers: { "Content-Type": "application/json" } }
                        );

                        if (uploadUrlResponse.data?.result) {
                            const uploadUrl = uploadUrlResponse.data.result;

                            // Upload file to S3
                            const uploadResponse = await axios.put(uploadUrl, file, {
                                headers: {
                                    "Content-Type": file.type,
                                    "Cache-Control": "no-cache",
                                },
                            });

                            if (uploadResponse.status === 200) {
                                console.log(`Uploaded: ${file.name}`);
                                return true;
                            } else {
                                throw new Error("Failed to upload file to S3");
                            }
                        } else {
                            throw new Error("Failed to get upload URL");
                        }
                    } catch (error) {
                        console.error("File upload error:", error);
                        return false;
                    }
                }
            });

            try {
                await Promise.all(uploadPromises);
                console.log("All files uploaded:", filesArray);
            } catch (error) {
                console.error("Error during file upload:", error);
            }
        }
    };



    const handleUploadfunction = async (files, caseid) => {
        if (!files || files.length === 0) return;

        // if (files && files.length > 0) {
        const uploadPromises = Array.from(files).map(async (file) => {
            const timestamp = Date.now();
            const fileExtension = file?.name?.split('.').pop();
            const clientid = localStorage.getItem('clientid');
            const token = localStorage.getItem('token');
            const ObjectID = require("bson-objectid");

            const uniqueId = new ObjectID().toString();
            let uploadFilePath;
            let bucket;
            console.log("filesssss-------> ", file)
            // Check the file type
            if (file) {
                // File is a video
                // uploadFilePath = `${clientid}/files/${uniqueId}_video_${timestamp}.${fileExtension}`;
                bucket = window.site && window.site.common && window.site.common.resourceBucket; // Use source bucket for videos
                // videoUploadFunction(uploadFilePath,bucket)
                const timestamp = Date.now();
                const fileExtension = file?.name?.split('.').pop();
                const clientid = localStorage.getItem('clientid');

                const ObjectID = require("bson-objectid");
                const uniqueId = new ObjectID().toString();
                const isTiff = file.type?.toLowerCase().includes('tiff') || file.type?.toLowerCase().includes('tif');
                console.log(' is tiff file', isTiff, file);

                const isLarge = file.size > 8 * 1024 * 1024;
                const uploadFilePath = (isTiff || isLarge)
                    ? `${appname}/cases/histology/${caseid}/${uniqueId}/`
                    : `${appname}/cases/histology-jpg/${caseid}/${uniqueId}/`;
                const fileNameUnique = `${uniqueId}_image_${timestamp}.${fileExtension}`;

                let uploads = JSON.parse(localStorage.getItem("uploads") || "[]");

                let uploadEntry = {
                    fileName: fileNameUnique,
                    uploadStatus: "INPROGRESS",
                    timestamp: timestamp
                };
                // let fileSize=12822600;
                //                     //let fileSize = 1048612 * 10 // 10MB
                //                     if (file?.size < fileSize) {
                //                         uploadEntry = {
                //                             fileName: fileNameUnique,
                //                             uploadStatus: "COMPLETED",
                //                             timestamp: timestamp
                //                         };
                //                     }

                uploads.push(uploadEntry);
                localStorage.setItem("uploads", JSON.stringify(uploads));

                const uploaderOptions = {
                    file: file,
                    baseURL: baseUrl,
                    chunkSize: partsize,
                    threadsQuantity: numuploads,
                    useTransferAcceleration: ta,
                    bucket: uploadFilePath,
                    fileNameUnique: fileNameUnique,
                    sourceBucket: bucket,
                    setIsUploading: setIsUploading,
                    setIsUploadingFailed: setIsUploadingFailed
                };

                let percentage = undefined;
                setPgvalue(0);
                setPerf("-");
                const uploader = new Uploader(uploaderOptions);
                const tBegin = performance.now();
                //console.log('tBegin', tBegin);
                // Get image dimensions before upload



                let newFile = {
                    fileCreated: new Date(),
                    filename: fileNameUnique,
                    filetype: file.type,
                    sourcepath: uploadFilePath + fileNameUnique,
                    fileid: uniqueId,
                    originalFilename: file.name,
                    uploadStatus: "INPROGRESS",
                    fileSize: file.size, // in bytes
                    width: fileDimension?.[file.name]?.width || 0,
                    height: fileDimension?.[file.name]?.height || 0,
                    resolution: fileDimension?.[file.name]?.resolution || 0,

                };
                if (isTiff || isLarge) {
                    newFile["allow"] = true;
                    newFile["allowDziCreation"] = true;

                }
                if ((!isLarge) && (file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/jpg')) {
                    newFile['dzistatus'] = 'COMPLETED'
                }

                console.log('newwww ', newFile)

                setUploadedFiles((uploadedFiles) => [...uploadedFiles, newFile]);



                uploader.start();


            } else {
                // File type is neither image nor video
                // toast.error('Unsupported file type');
                return;
            }
            //  console.log('Upload File Path:', uploadFilePath);

        });

        try {
            //const results = await Promise.all(uploadPromises);
            await Promise.all(uploadPromises);


        } catch (error) {
            console.error('Error during file upload:', error);
        }
        // }

    };
    const handlePopupImage = (imageUrl) => {
        setShowImagePopup(true);
        setPopupImage(imageUrl);
        setClinicalPopupList([]);
        setClinicalPopupIndex(0);
    };

    const handleClinicalPopupOpen = (list, index) => {
        setShowImagePopup(true);
        setIsClinicalLoading(true);
        setPopupImage(list[index]);
        setClinicalPopupList(list);
        setClinicalPopupIndex(index);
    };

    const navigateClinicalImage = (newIndex) => {
        if (!clinicalPopupList.length) return;
        const clamped = Math.max(0, Math.min(newIndex, clinicalPopupList.length - 1));
        setIsClinicalLoading(true);
        setPopupImage(clinicalPopupList[clamped]);
        setClinicalPopupIndex(clamped);
    };

    const updateFilesAPI = () => {
        // Safety check
        if (!caseIdDynamic) {
            console.error('updateFilesAPI: caseIdDynamic is null, skipping update');
            return;
        }

        console.log('caseid dynamic', caseIdDynamic);
        let payload = { files: uploadedFiles, caseid: caseIdDynamic };

        axios({
            method: 'POST',
            url: lambda + "/updateLearningCase?appname=" + appname + '&caseid=' + caseIdDynamic,
            data: payload,
        })
            .then(function (response) {
                setImageFiles([]);
                setImageUrls([]);
                setUploadedFiles([]);
            })
            .catch(function (error) {
                console.error('updateFilesAPI error:', error);
            });
    }


    const handleChange = (e) => {
        const { name, value } = e.target;


        if (name === "usertype") {
            if (id) {
                setCheckStatus(true);
            }
            setEditUser(prev => ({ ...prev, [name]: value }));
        }


        if (name === "diagnosisid" && value.trim() !== "") {
            setdiagnosisIdError("");
        }
        if (name === "phone") {
            let formattedValue = value;
            let numericValue = value.replace(/\D/g, ""); // Remove non-numeric characters
            const currentIdc = editUser?.idc?.trim(); // Remove unnecessary spaces

            if (currentIdc === "USA") {
                console.log("Using USA Format");
                if (numericValue.length > 10) numericValue = numericValue.slice(0, 10);
                if (numericValue.length > 6) {
                    formattedValue = `(${numericValue.slice(0, 3)}) ${numericValue.slice(3, 6)}-${numericValue.slice(6)}`;
                } else if (numericValue.length > 3) {
                    formattedValue = `(${numericValue.slice(0, 3)}) ${numericValue.slice(3)}`;
                } else {
                    formattedValue = numericValue;
                }
            } else if (currentIdc === "IND") {
                console.log("Using India Format");
                if (numericValue.length > 10) numericValue = numericValue.slice(0, 10);
                if (numericValue.length > 5) {
                    formattedValue = `${numericValue.slice(0, 5)}-${numericValue.slice(5)}`;
                } else {
                    formattedValue = numericValue;
                }
            }

            // Update the phone number only
            setEditUser(prev => ({ ...prev, phone: formattedValue }));
            return; // Stop further execution for "phone" field
        }

        else if (name === "manager") {
            for (let key in manager) {
                if (manager.hasOwnProperty(key) && manager[key].userid === value) {
                    setEditUser(prev => ({ ...prev, [name]: value }));
                    break; // No need to continue looping after finding the match
                }
            }
        }

        else if (name === "status") {
            if (id) {
                setCheckStatus(true);
            }
            setEditUser(prev => ({ ...prev, [name]: value }));
        } else if (name == "assignedCpc") {
            let assignedCpcValue = value.split("|")
            console.log("valddd ", value, assignedCpcValue[0], assignedCpcValue[1])
            setEditUser(prev => ({ ...prev, "assignedCpc": assignedCpcValue[0], "assignedCpcTitle": assignedCpcValue[1] }));
        } else {
            setEditUser(prev => ({ ...prev, [name]: value }));
        }


    };
    const handleChangeMultiSelect = (selected, key) => {
        setEditUser({ ...editUser, [key]: selected });

    }
    function onConfirm() {
        setSuccess(false);
        navigate("/cases", { state: { restoreListPage: true } })
    };
    function onConfirmAnswer() {
        setSuccessAnswer(false);
        setShowPopup(false);
        // navigate("/cases")
        setFormData((prevData) => ({
            ...prevData, // Keep the other fields intact
            "answer": "", // Update the changed field
        }));
    };
    function onUpdateConfirm() {
        setUpdateSuccess(false);
        getLearningCaseInfo()

        if (imageFiles && imageFiles.length > 0) {
            setImageUrls(null);
            setImageFiles([])
            setImageIndex(0)
        }

        if (clinicalimageFiles && clinicalimageFiles.length > 0) {
            setClinicalImageUrls(null);
            setclinicalImageFiles([])
            setClinicalImageIndex(0)
        }

    };

    const handleAddUser = (e, status) => {
        GetTimeActivity()
        const isValid = formvalidation();
        if (isValid) {
            const caseid = uuid();
            // if (imageFiles && imageFiles.length > 0) {
            //   handleFileUpload(caseid, "create")
            // } else {
            createuser(imageFiles, caseid, status);
            //  }

        } else {
            toast.error("Please fill all required fields", {
                position: "bottom-center",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        }
    }
    console.log('diagnosisid', editUser?.diagnosisid)

    function formvalidation() {
        GetTimeActivity()
        let formIsValid = true;

        if (editUser?.diagnosis === undefined || editUser?.diagnosis?.trim() === "") {
            setdiagnosisError("Please enter Diagnosis");
            // setTimeout(function () { setdiagnosisError("") }, 3000);
            formIsValid = false;
        } else {
            setdiagnosisError("")
        }
        if (editUser?.diagnosisid === undefined || editUser?.diagnosisid?.trim() === "") {
            setdiagnosisIdError("Please enter Case number");
            // setTimeout(function () { setdiagnosisError("") }, 3000);
            formIsValid = false;
        } else {
            setdiagnosisIdError("")
        }

        // if (id && tags && tags?.length == 0) {
        //     settagError("Please enter Tags");
        //     // setTimeout(() => settagError(""), 3000);
        //     formIsValid = false;
        // } else {
        //     settagError("")
        // }

        if (id && (editUser?.clinicalhistory === undefined || editUser?.clinicalhistory?.trim() === "")) {
            setdescriptionError("Please enter Clinical history");
            // setTimeout(function () { setdescriptionError("") }, 3000);
            formIsValid = false;
        } else {
            setdescriptionError("")
        }

        if (id && !editUser?.explanation?.trim()) {
            setexplanationError("Please enter Explanation");
            //  setTimeout(() => setexplanationError(""), 3000);
            formIsValid = false;
        } else {
            setexplanationError("")
        }

        // if (id && !editUser?.answer1?.value) {
        //     setanswer1Error("Please select answer (1 Point)");
        //     //setTimeout(() => setanswer1Error(""), 3000);
        //     formIsValid = false;
        // } else {
        //     setanswer1Error("")
        // }



        return formIsValid;
    }

    useEffect(() => {
        // Clear diagnosis error if the diagnosis field is filled
        if (editUser?.diagnosis?.trim() !== "") {
            setdiagnosisError(""); // Clear the error message
        }

        // Clear tag error if tags are provided (and length is greater than 0)
        // if (id && tags && tags?.length > 0) {
        //     settagError(""); // Clear the error message
        // }

        // Clear clinical history error if clinical history is filled
        if (id && editUser?.clinicalhistory?.trim() !== "") {
            setdescriptionError(""); // Clear the error message
        }

        // Clear explanation error if explanation is filled
        if (id && editUser?.explanation?.trim() !== "") {
            setexplanationError(""); // Clear the error message
        }

        // Clear answer1 error if the answer1 is selected
        if (id && editUser?.answer1?.value) {
            setanswer1Error(""); // Clear the error message
        }

    }, [editUser, id]); // Trigger this effect when editUser, id, or tags change




    // Determines photo type from newly uploaded files
    const determinePhotoTypeFromUploads = (imageFiles = []) => {
        const types = imageFiles.map(file => file.type.toLowerCase());

        const hasJPEG = types.some(type =>
            type.includes("jpeg") || type.includes("jpg") || type.includes("png")
        );
        const hasTIFF = types.some(type =>
            type.includes("tiff") || type.includes("tif")
        );

        if (hasJPEG && hasTIFF) return "TIFF/JPEG";
        if (hasTIFF) return "TIFF";
        if (hasJPEG) return "JPEG";
        return "";
    };
    // Determines photo type from both existing files and newly uploaded files
    const determinePhotoTypeFromAllFiles = (imageFiles = [], filesData = []) => {
        const uploadedTypes = imageFiles.map(file => file.type?.toLowerCase() || "");
        const existingTypes = filesData.map(file => file.filetype?.toLowerCase() || file.name?.toLowerCase() || "");

        const allTypes = [...uploadedTypes, ...existingTypes];

        const hasJPEG = allTypes.some(type =>
            type.includes("jpeg") || type.includes("jpg") || type.includes("png")
        );
        const hasTIFF = allTypes.some(type =>
            type.includes("tiff") || type.includes("tif")
        );

        if (hasJPEG && hasTIFF) return "TIFF/JPEG";
        if (hasTIFF) return "TIFF";
        if (hasJPEG) return "JPEG";
        return "";
    };
    useEffect(() => {
        if (!id && imageFiles?.length) {
            setHistologyPhotoTypeSafe(determinePhotoTypeFromUploads(imageFiles));
        }
    }, [imageFiles, id]);

    // useEffect(() => {
    //     if (id) {
    //         setHistologyPhotoTypeSafe(determinePhotoTypeFromAllFiles(imageFiles, FilesData));
    //     }
    // }, [imageFiles, FilesData, id]);
    useEffect(() => {
        if (id && (imageFiles?.length > 0 || FilesData?.length > 0)) {
            // Only recompute if there's actually something to work with
            setHistologyPhotoTypeSafe(determinePhotoTypeFromAllFiles(imageFiles, FilesData));
        }
    }, [imageFiles, FilesData, id]);
    console.log('edit user,', editUser, imageFiles, !id, histologyPhotoType, FilesData)

    useEffect(() => {
        console.log('case id dynamic', caseIdDynamic)
    }, [setCaseId])
    const handleSubmit = async (status) => {
        console.log("handleSubmit: start");
        try {
            GetTimeActivity();
        } catch (err) {
            console.warn("GetTimeActivity failed:", err);
        }

        setIsLoading(true);
        setLoadingButton("submit"); // optional: show button loader

        // build payload
        try {
            const token = localStorage.getItem("token");
            const payload = {
                diagnosis: editUser?.diagnosis ?? "",
                clinicalhistory: editUser?.clinicalhistory ?? "",
                youtube: editUser?.youtube ?? "",
                // tags: Array.isArray(tags) ? tags : [],
                explanation: editUser?.explanation ?? "",
                answer1: editUser?.answer1 ?? "",
                answer11: editUser?.answer11 ?? "",
                answer2: editUser?.answer2 ?? "",
                // Always include moduleids (empty array if none)
                moduleids: Array.isArray(moduleIdList) ? moduleIdList : [],
                diagnosisid: editUser?.diagnosisid ?? ""
            };

            if (id) {
                payload.histologyPhotoType = histologyPhotoTypeRef.current; // ✅ always current

                // payload.histologyPhotoType = histologyPhotoType;
                payload.caseid = id;
            }
            if (status) {
                payload.status = status;
            }

            if (editUser?.youtube) {
                try {
                    const vid = getYouTubeVideoId(editUser.youtube);
                    if (vid) {
                        payload.thumbnail = `https://img.youtube.com/vi/${vid}/0.jpg`;
                    }
                } catch (err) {
                    console.warn("getYouTubeVideoId failed:", err);
                }
            }

            if (editUser?.assignedCpc) {
                payload.assignedCpc = editUser.assignedCpc;
            }
            if (editUser?.assignedCpcTitle) {
                payload.assignedCpcTitle = editUser.assignedCpcTitle;
            }
            if (editUser?.assignedModule) {
                payload.assignedModule = editUser.assignedModule;
            }

            // if images exist you may want to set some flag - leaving commented as before
            // if (imageFiles && imageFiles.length > 0) { payload.imageStatus = 'INPROGRESS' }

            console.debug("handleSubmit: payload prepared:", payload);

            // axios request - include token header if present
            const axiosConfig = {
                method: "POST",
                url: `${lambda}/updateLearningCase?appname=${appname}&caseid=${id}&moduleCase=true`,
                data: payload,
                headers: {},
            };
            if (token) {
                axiosConfig.headers["Authorization"] = `Bearer ${token}`;
            }

            const response = await axios(axiosConfig);
            console.debug("handleSubmit: raw response:", response);

            // safe checks for response
            const respData = response?.data ?? response;
            // handle token error (your original code had response?.result === "Invalid token or Expired")
            if (respData?.result === "Invalid token or Expired" || respData?.data === "Invalid token or Expired") {
                console.warn("Session invalid or expired:", respData);
                setIsLoading(false);
                setShowSessionPopupup(true);
                setLoadingButton(null);
                return;
            }
            if (respData?.data === "Case with same diagnosisid already exists" || respData?.result === "Case with same diagnosisid already exists") {
                console.info("Case with same diagnosisid already exists", respData);
                setIscaseExist(true);
                setIsLoading(false);
                setLoadingButton(null);
                return respData;
            }
            if (respData?.data === "CaseID Already Exists" || respData?.result === "CaseID Already Exists") {
                console.info("Case with same diagnosisid already exists", respData);
                setIscaseExist(true);
                setIsLoading(false);
                setLoadingButton(null);
                return respData;
            }


            // handle specific API message
            if (respData?.data === "This ACM assaigned to companies") {
                console.info("ACM assigned to companies response:", respData);
                setIsMsg(true);
                setIsLoading(false);
                setLoadingButton(null);
                return;
            }

            // Success path
            console.info("handleSubmit: API success:", respData);
            setCaseId(id);

            // kick off uploads (if any) but guard with try/catch so errors don't break flow
            try {
                if (imageFiles && imageFiles.length > 0) {
                    console.log("handleSubmit: starting imageFiles upload", imageFiles.length);
                    await handleUploadfunction(imageFiles, id);
                    console.log("handleSubmit: imageFiles upload finished");
                }
            } catch (err) {
                console.error("handleUploadfunction failed:", err);
                // optionally set a flag to show upload partial-failure
            }

            try {
                if (clinicalimageFiles && clinicalimageFiles.length > 0) {
                    console.log("handleSubmit: starting clinicalimageFiles upload", clinicalimageFiles.length);
                    await handleFileUpload(clinicalimageFiles, id);
                    console.log("handleSubmit: clinicalimageFiles upload finished");
                }
            } catch (err) {
                console.error("handleFileUpload failed:", err);
            }

            // final UI success handling
            setIsLoading(false);
            setLoadingButton(null);
            setUpdateSuccess(true);
            setSuccessMsg("Updated Successfully");
            console.log("handleSubmit: update successful, navigating to /cases in 2s");

            // keep original delayed navigation for UX
            setTimeout(() => {
                navigate("/cases", { state: { restoreListPage: true } });
            }, 2000);

        } catch (err) {
            // network / unexpected error
            console.error("handleSubmit: failed:", err);
            // show user-friendly error where appropriate (you may already have toasts)
            setIsLoading(false);
            setLoadingButton(null);
            // optional: set an error state to show in the UI
        } finally {
            // ensure loaders are reset in all cases
            setIsLoading(false);
            setLoadingButton(null);
            console.log("handleSubmit: finished (finally)");
        }
    };


    const handleUpdate = (e, status) => {
        setLoadingButton(status);  // show loader only on clicked button
        GetTimeActivity();

        if (status === "ACTIVE") {
            const isValid = formvalidation();
            if (isValid) {
                handleSubmit(status);
            } else {
                toast.error("Please fill all required fields", {
                    position: "bottom-center",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
            }
        } else {
            setLoadingButton(null);
            if (editUser?.diagnosisid === undefined || editUser?.diagnosisid?.trim() === "") {
                setdiagnosisIdError("Please enter Case number");
                toast.error("Please enter Case number", {
                    position: "bottom-center",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
            } else {

                setdiagnosisIdError("");
                handleSubmit(status);
            }
            // handleSubmit(status);
        }


    };








    const createuser = async (imageFiles, caseid, status) => {
        console.log("createuser: start", { caseid, status, imageFilesCount: imageFiles?.length ?? 0 });
        setIsLoading(true);
        setLoadingButton("create");

        // ✅ FIX: Set caseIdDynamic immediately when function is called
        setCaseId(caseid);

        try {
            // build payload with defaults
            const payload = {
                diagnosis: editUser?.diagnosis ?? "",
                clinicalhistory: editUser?.clinicalhistory ?? "",
                youtube: editUser?.youtube ?? "",
                explanation: editUser?.explanation ?? "",
                // tags: Array.isArray(tags) ? tags : [],
                answer1: editUser?.answer1 ?? "",
                answer11: editUser?.answer11 ?? "",
                answer2: editUser?.answer2 ?? "",
                caseid: caseid,
                status: status,
                diagnosisid: editUser?.diagnosisid,
                moduleids: Array.isArray(moduleIdList) ? moduleIdList : [],
            };

            if (editUser?.youtube) {
                try {
                    const vid = getYouTubeVideoId(editUser.youtube);
                    if (vid) payload.thumbnail = `https://img.youtube.com/vi/${vid}/0.jpg`;
                } catch (err) {
                    console.warn("createuser: getYouTubeVideoId failed", err);
                }
            }

            if (editUser?.assignedCpc) payload.assignedCpc = editUser.assignedCpc;
            if (editUser?.assignedCpcTitle) payload.assignedCpcTitle = editUser.assignedCpcTitle;
            if (editUser?.assignedModule) payload.assignedModule = editUser.assignedModule;

            if (!id) {
                payload.histologyPhotoType = histologyPhotoType;
            }

            console.debug("createuser: payload prepared:", payload);

            const userId = localStorage.getItem("userId");
            if (!userId) {
                console.warn("createuser: userId not found in localStorage");
            }

            const token = localStorage.getItem("token");
            const axiosConfig = {
                method: "POST",
                url: `${lambda}/addLearningCase?appname=${appname}&userid=${userId}`,
                data: payload,
                headers: {},
            };
            if (token) {
                axiosConfig.headers["Authorization"] = `Bearer ${token}`;
            }

            const response = await axios(axiosConfig);
            console.debug("createuser: API response:", response);

            const respData = response?.data ?? response;

            if (respData?.data === "User already exists" || respData?.result === "User already exists") {
                console.info("createuser: User already exists response:", respData);
                setExistMsg(true);
                setIsLoading(false);
                setLoadingButton(null);
                return respData;
            }
            if (respData?.data === "Case with same diagnosisid already exists" || respData?.result === "Case with same diagnosisid already exists") {
                console.info("Case with same diagnosisid already exists", respData);
                setIscaseExist(true);
                setIsLoading(false);
                setLoadingButton(null);
                return respData;
            }
            if (respData?.result === "Invalid token or Expired" || respData?.data === "Invalid token or Expired") {
                console.warn("createuser: Invalid token or expired:", respData);
                setShowSessionPopupup(true);
                setIsLoading(false);
                setLoadingButton(null);
                return respData;
            }

            // On success, kickoff uploads
            try {
                if (imageFiles && imageFiles.length > 0) {
                    console.log("createuser: uploading imageFiles count:", imageFiles.length);
                    await handleUploadfunction(imageFiles, caseid);
                    console.log("createuser: imageFiles upload finished");
                }
            } catch (err) {
                console.error("createuser: handleUploadfunction error:", err);
            }

            try {
                if (clinicalimageFiles && clinicalimageFiles.length > 0) {
                    console.log("createuser: uploading clinicalimageFiles count:", clinicalimageFiles.length);
                    await handleFileUpload(clinicalimageFiles, caseid);
                    console.log("createuser: clinicalimageFiles upload finished");
                }
            } catch (err) {
                console.error("createuser: handleFileUpload error:", err);
            }

            // final success UI updates
            setCaseId(caseid);
            setIsLoading(false);
            setLoadingButton(null);
            setSuccess(true);
            setSuccessMsg("Created Successfully");
            console.info("createuser: Created successfully", respData);

            return respData;
        } catch (err) {
            console.error("createuser: failed:", err);
            setIsLoading(false);
            setLoadingButton(null);
            return { error: true, message: err?.message ?? "Unknown error" };
        } finally {
            setIsLoading(false);
            setLoadingButton(null);
            console.log("createuser: finished (finally)");
        }
    };

    const handleBack = () => {
        GetTimeActivity();
        navigate("/cases", { state: { restoreListPage: true } });
    };

    const handleBackOld = (e) => {
        GetTimeActivity()
        if (id) {
            navigate({
                pathname: "/cases",
                state: { search: true }
            });
        } else {
            navigate("/cases", { state: { restoreListPage: true } })
        }
    }
    const CancelClick = () => {
        GetTimeActivity()
        setIsMsg(false);
        navigate("/cases", { state: { restoreListPage: true } })
    }





    const handlePopupload = (e) => {
        setPopupLoading(true)
    }

    const imageFileDelete = async (e) => {
        setdeleteImage(false)
        try {
            let params = {
                "source_bucket": resourceBucket,
                "sourcepath": deleteImageId?.sourcepath,
            }

            if (deleteimageType == "file") {

                await tmdbApi.deleteHistoricFiles(id, { ...params, "filename": deleteImageId?.filename });
                setEditUser((prev) => ({
                    ...prev,
                    historyfiles: prev.historyfiles?.filter(
                        (file) => file.fileid !== deleteImageId.fileid
                    ),
                }));
            } else {

                await tmdbApi.deleteOmeFiles(id, { ...params, "fileid": deleteImageId?.fileid });
                setEditUser((prev) => ({
                    ...prev,
                    files: prev.files.filter(
                        (file) => file.fileid !== deleteImageId.fileid
                    ),
                }));
            }




            setDeleteImageSuccess(true)
        } catch {
            console.log("error");
        }
    }

    const onDelImageCancel = (e) => {
        setdeleteImage(false)
        setDeleteImageId(null)

    }
    // console.log('imdadfadfad', deleteImageId)
    const ondeleteImageConfirm = (e) => {
        setDeleteImageSuccess(false)
        setDeleteImageId(null)
    }

    const toggleSelectMode = () => {
        setIsSelectMode(prev => !prev);
        setSelectedFiles([]);
    };

    const toggleFileSelection = (fileid, type, item) => {
        setSelectedFiles(prev => {
            const exists = prev.find(f => f.fileid === fileid);
            if (exists) return prev.filter(f => f.fileid !== fileid);
            return [...prev, { fileid, type, item }];
        });
    };

    const handleMultiDelete = () => {
        if (selectedFiles.length === 0) return;
        setDeleteMultipleImages(true);
    };

    const executeMultiDelete = async () => {
        setDeleteMultipleImages(false);
        setIsMultiDeleting(true);
        const toDelete = [...selectedFiles];
        try {
            for (const { fileid, type, item } of toDelete) {
                const params = { source_bucket: resourceBucket, sourcepath: item?.sourcepath };
                if (type === "file") {
                    await tmdbApi.deleteHistoricFiles(id, { ...params, filename: item?.filename });
                } else {
                    await tmdbApi.deleteOmeFiles(id, { ...params, fileid });
                }
            }
            const deletedOmeIds = toDelete.filter(f => f.type === "ome").map(f => f.fileid);
            const deletedHistoryIds = toDelete.filter(f => f.type === "file").map(f => f.fileid);
            setEditUser(prev => ({
                ...prev,
                files: prev.files?.filter(f => !deletedOmeIds.includes(f.fileid)),
                historyfiles: prev.historyfiles?.filter(f => !deletedHistoryIds.includes(f.fileid)),
            }));
            setSelectedFiles([]);
            setIsSelectMode(false);
            setDeleteMultipleSuccess(true);
        } catch {
            console.log("multi delete error");
        } finally {
            setIsMultiDeleting(false);
        }
    };

    const cancelMultiDelete = () => {
        setDeleteMultipleImages(false);
    };

    const confirmMultiDeleteSuccess = () => {
        setDeleteMultipleSuccess(false);
    };

    // console.log("imageFiles", imagesUrls, imageFiles);

    const handleSelectChange = (selectedOption, aIndex) => {
        console.log("selectedOption:", selectedOption, "aIndex:", aIndex);

        const isFullPoint = aIndex === "answer1" || aIndex === "answer11";
        const updatedPoint = isFullPoint ? 1 : 0.5;

        setEditUser(prevData => ({
            ...prevData,
            [aIndex]: {
                ...selectedOption,
                points: updatedPoint
            }
        }));
    };


    const handleInputChange = (inputValue, aIndex) => {

        if (inputValue !== "") {
            const results = answers?.filter(option =>
                option.label.toLowerCase().includes(inputValue.toLowerCase())
            );
            setFilteredOptionsMap(prev => ({
                ...prev,
                [`${aIndex}`]: results
            }));
        } else {
            setFilteredOptionsMap(prev => ({
                ...prev,
                [`${aIndex}`]: answers
            }));
        }
    };



    const getExtension = (filename) => {
        if (!filename) return null;
        let extType = filename.split('.').pop().toLowerCase();
        let valReturn = ".jpeg,.jpg,.png";
        if (extType === 'tiff' || extType === 'tif') {
            valReturn = ".tif,.tiff";
        }
        return valReturn
    };



    return (
        <>
            {

                showSessionPopupup &&

                <SessionPopup

                />}
            <div id="layout-wrapper" className="editcase-mob-res editcase-mob-1">
                <Header />
                <SideMenu />


                {/* <SweetAlert show={invalidContent}
                    custom
                    confirmBtnText="ok"
                    confirmBtnBsStyle="primary"
                    title={"User Not Found"}
                    onConfirm={e => onclickInvalid()}
                >
                </SweetAlert> */}
                {!invalidContent &&

                    <div className="main-content user-management create-user" id="main-content">
                        <div className="page-content" id="page-content">
                            <div className="container-fluid" id="container-fluid">
                                <div className="row mb-4 breadcrumb" id="breadcrumb-row">
                                    <div className="col-lg-12">
                                        <div className="d-flex align-items-center">
                                            <div className="flex-grow-1">
                                                <h4 className="mb-2 card-title" id="breadcrumb-title">{id === undefined ? "CASE DETAILS" : "EDIT CASE"}</h4>
                                                <p className="menu-path" id="breadcrumb-path">
                                                    <span>Learning Hub</span> / <b id="breadcrumb-action">{id === undefined ? "ADD CASE" : "EDIT CASE"}</b>
                                                </p>
                                            </div>
                                            <div>
                                                <a id="back-button" onClick={handleBack} className="stroke-btn-style create-quiz-btn">back
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="create-user-block" id="create-user-block">
                                    {

                                        !loading

                                            // && Object.keys(editUser)?.length > 0 
                                            ?

                                            (
                                                <>
                                                    <div className="form-block" id="form-block">
                                                        <div className="row">
                                                            <div className="d-flex flex-wrap col-lg-12 col-md-12 justify-content-between align-items-start">
                                                                <div className="col-lg-6">

                                                                     {/* <GoogleFormEmbed /> */}
                                                                    <b className="mb-2 answer-text">Case Info</b>

                                                                    <div className="col-lg-12 col-md-12 mt-2">
                                                                        <div className="mb-3 input-field">
                                                                            <label className="form_label">Case Number<span className="required">*</span></label>
                                                                            <input id="diagnosisid" name="diagnosisid" placeholder="Enter Case number" type="text" className="form-control" aria-invalid="false" onChange={(e) => handleChange(e)}
                                                                                // disabled={id !== undefined} 

                                                                                value={editUser?.diagnosisid} />
                                                                            <span id="diagnosis-error" className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{diagnosisIdError}</span>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-lg-12 col-md-12 mt-2">
                                                                        <div className="mb-3 input-field">
                                                                            <label className="form_label">DIAGNOSIS<span className="required">*</span></label>
                                                                            <input id="diagnosis" name="diagnosis" placeholder="Enter Diagnosis" type="text" className="form-control" aria-invalid="false" onChange={(e) => handleChange(e)} value={editUser?.diagnosis} />
                                                                            <span id="diagnosis-error" className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{diagnosisError}</span>
                                                                        </div>
                                                                    </div>

                                                                    <div className="col-lg-12 col-md-12">
                                                                        <div className="mb-3 input-field clinical-history">
                                                                            <label className="form-label form-label">Clinical History
                                                                            </label>

                                                                            <Editor name="clinicalhistory" value={editUser?.clinicalhistory} onChange={(e) => onDescriptionChange(e)} />

                                                                            <span id="status-error" className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{descriptionError}</span>



                                                                        </div>
                                                                    </div>

                                                                    {/* <div className="col-lg-12 col-md-12">
                                                                <div className="mb-3 input-field">

                                                                    <label className="form_label">Tags
                                                                    </label>

                                                                    <div className="mb-3 input-field tags-mob-wid">

                                                                        <div className="tags-mob-wid-input"
                                                                        >
                                                                            
                                                                            <CreatableSelect
                                                                                isMulti
                                                                                options={options}
                                                                                value={selectedTags}
                                                                                onChange={handleChangeTags}
                                                                                placeholder="Type and press Enter"
                                                                                styles={{
                                                                                    multiValue: (base) => ({
                                                                                        ...base,
                                                                                        backgroundColor: "#e0e0e0",
                                                                                        borderRadius: "6px",
                                                                                        padding: "2px 6px",
                                                                                    }),
                                                                                }}
                                                                            />

                                                                        </div>
                                                                    </div>

                                                                </div>
                                                            </div> */}
                                                                    <div className="col-lg-12 col-md-12">

                                                                    </div>
                                                                    <div className="row">

                                                                    </div>
                                                                    <div>

                                                                    </div>
                                                                    <div className="col-lg-12 mt-4">
                                                                        {/* ── Multi-select action bar ─────────────────────── */}
                                                                        {!isRestricted && id && ((editUser?.historyfiles?.length > 0) || (editUser?.files?.length > 0)) && (
                                                                            <div className="multi-select-action-bar">
                                                                                {isSelectMode ? (
                                                                                    <span className="select-mode-hint">
                                                                                        {selectedFiles.length === 0
                                                                                            ? 'Click thumbnails to select files'
                                                                                            : `${selectedFiles.length} file${selectedFiles.length !== 1 ? 's' : ''} selected`}
                                                                                    </span>
                                                                                ) : null}
                                                                                {isSelectMode && selectedFiles.length > 0 && (
                                                                                    <button
                                                                                        type="button"
                                                                                        className="btn-delete-selected"
                                                                                        onClick={handleMultiDelete}
                                                                                        disabled={isMultiDeleting}
                                                                                    >
                                                                                        {isMultiDeleting ? (
                                                                                            <>
                                                                                                <span className="material-symbols-outlined" style={{ fontSize: '13px' }}>hourglass_empty</span>
                                                                                                Deleting...
                                                                                            </>
                                                                                        ) : (
                                                                                            <>
                                                                                                <span className="material-symbols-outlined" style={{ fontSize: '13px' }}>delete</span>
                                                                                                Delete Selected
                                                                                                <span className="delete-count-badge">{selectedFiles.length}</span>
                                                                                            </>
                                                                                        )}
                                                                                    </button>
                                                                                )}
                                                                                <button
                                                                                    type="button"
                                                                                    className={`btn-select-files${isSelectMode ? ' is-cancel' : ''}`}
                                                                                    onClick={toggleSelectMode}
                                                                                >
                                                                                    {isSelectMode ? (
                                                                                        <>
                                                                                            <span className="material-symbols-outlined" style={{ fontSize: '13px' }}>close</span>
                                                                                            Cancel
                                                                                        </>
                                                                                    ) : (
                                                                                        <>
                                                                                            <span className="material-symbols-outlined" style={{ fontSize: '13px' }}>checklist</span>
                                                                                            Select Files
                                                                                        </>
                                                                                    )}
                                                                                </button>
                                                                            </div>
                                                                        )}
                                                                        {/* ── 1. CLINICAL HISTORY PHOTOS ─────────────────────── */}
                                                                        <div className="col-md-12 upload-imgs">
                                                                            <div className="d-flex col-lg-12 align-items-start justify-content-between upload-img-section">
                                                                                <label className="form_label col-4">CLINICAL HISTORY PHOTOS</label>
                                                                                <p className="mt-0 mb-0 text-muted col-8 file-format">Note: Max File size: 20 MB , Max files: 10 | Formats: JPG, PNG</p>
                                                                            </div>

                                                                            <div className="d-flex justify-content-start col-lg-12 clinical-photo-section gap-3 mt-3">



                                                                                {/* Uploaded clinical images */}
                                                                                {/* THUMBNAIL GRID */}
                                                                                <div className="deep-zoom-styles mb-3 mt-1" /* grid container */>
                                                                                    {/* ── Clinical images from local upload ─────────────────── */}
                                                                                    <div className="upload-box">
                                                                                        <div className="file_upload add-box">
                                                                                            <input
                                                                                                type="file"
                                                                                                id="file-upload"
                                                                                                accept="image/jpeg, image/png"
                                                                                                className="file-input"
                                                                                                multiple
                                                                                                disabled={isRestricted}
                                                                                                onChange={handleimageFileChange}
                                                                                                onClick={(e) => {

                                                                                                    e.target.value = null;
                                                                                                }}
                                                                                                style={{ display: "none" }}
                                                                                            />
                                                                                            <label htmlFor="file-upload" className="Add-btn d-flex align-items-center justify-content-center flex-column">
                                                                                                <p className="mb-0">
                                                                                                    <span className="material-symbols-outlined plus-icon">add</span>
                                                                                                </p>
                                                                                                ADD
                                                                                            </label>
                                                                                        </div>
                                                                                        {/* <div className="file_requirements mt-2 small text-muted">
                                                                                <p className="mb-1">File size: 20 MB</p>
                                                                                <p className="mb-0">Formats: JPG, PNG</p>
                                                                            </div> */}
                                                                                    </div>

                                                                                    {clinicalimagesUrls &&
                                                                                        Object.keys(clinicalimagesUrls).map((item, key) => (
                                                                                            <div className="thumb-box" key={key}>
                                                                                                <div
                                                                                                    className="thumb-img cursor-pointer"
                                                                                                    onClick={() => {
                                                                                                        const blobUrls = Object.keys(clinicalimagesUrls).map(k => clinicalimagesUrls[k].url);
                                                                                                        const serverUrls = (editUser?.historyfiles || []).map(f => `${imageCloudfront}${f?.sourcepath?.replace(/ /g, '%20')}?auto=compress,format`);
                                                                                                        const list = [...blobUrls, ...serverUrls];
                                                                                                        handleClinicalPopupOpen(list, key);
                                                                                                    }}
                                                                                                >
                                                                                                    <img
                                                                                                        src={clinicalimagesUrls[item].url}
                                                                                                        alt="uploaded"
                                                                                                    />

                                                                                                    <span
                                                                                                        className="icon-close"
                                                                                                        onClick={(e) => {
                                                                                                            e.stopPropagation();
                                                                                                            handleClinicalImageDelete(e, item, key, "file");
                                                                                                        }}
                                                                                                    >
                                                                                                        ×
                                                                                                    </span>
                                                                                                </div>
                                                                                                {/* <p className="thumb-name text-truncate small mb-0">
                                                                                            {clinicalimagesUrls[item].name}
                                                                                        </p> */}
                                                                                            </div>
                                                                                        ))}



                                                                                    {/* ── Clinical images from editUser.historyfiles ─────────── */}
                                                                                    {editUser?.historyfiles?.length > 0 &&
                                                                                        editUser.historyfiles.map((item, key) => {
                                                                                            const imagePath = `${imageCloudfront}${item?.sourcepath?.replace(/ /g, '%20')
                                                                                                }?auto=compress,format`;
                                                                                            const isSelected = selectedFiles.some(f => f.fileid === item.fileid);
                                                                                            return (
                                                                                                <div
                                                                                                    className={`thumb-box${isSelectMode && isSelected ? ' file-selected' : ''}`}
                                                                                                    key={key}
                                                                                                    onClick={() => { if (isSelectMode) toggleFileSelection(item.fileid, 'file', item); }}
                                                                                                    style={isSelectMode ? { cursor: 'pointer' } : {}}
                                                                                                >
                                                                                                    <div
                                                                                                        className="thumb-img cursor-pointer"
                                                                                                        onClick={() => {
                                                                                                            if (isSelectMode) return;
                                                                                                            const blobUrls = clinicalimagesUrls ? Object.keys(clinicalimagesUrls).map(k => clinicalimagesUrls[k].url) : [];
                                                                                                            const serverUrls = (editUser?.historyfiles || []).map(f => `${imageCloudfront}${f?.sourcepath?.replace(/ /g, '%20')}?auto=compress,format`);
                                                                                                            const list = [...blobUrls, ...serverUrls];
                                                                                                            handleClinicalPopupOpen(list, blobUrls.length + key);
                                                                                                        }}
                                                                                                    >
                                                                                                        {isSelectMode && (
                                                                                                            <input
                                                                                                                type="checkbox"
                                                                                                                className="select-file-checkbox"
                                                                                                                checked={isSelected}
                                                                                                                onChange={() => toggleFileSelection(item.fileid, 'file', item)}
                                                                                                                onClick={e => e.stopPropagation()}
                                                                                                            />
                                                                                                        )}
                                                                                                        <img src={`${imagePath}&width=150`} alt="history"
                                                                                                            onError={(e) => {
                                                                                                                e.currentTarget.onerror = null;
                                                                                                                e.currentTarget.src = deepZoom;
                                                                                                            }}
                                                                                                        />
                                                                                                        {!isSelectMode && (
                                                                                                            <span
                                                                                                                className="icon-close"
                                                                                                                onClick={(e) => {
                                                                                                                    e.stopPropagation();
                                                                                                                    handleImageFileDelete(e, item, key, 'file');
                                                                                                                }}
                                                                                                            >
                                                                                                                ×
                                                                                                            </span>
                                                                                                        )}

                                                                                                    </div>
                                                                                                    {/* <p className="thumb-name text-truncate small mb-0">
                                                                                                {item.filename}
                                                                                            </p> */}
                                                                                                </div>
                                                                                            );
                                                                                        })}
                                                                                </div>

                                                                            </div>
                                                                        </div>

                                                                        {/* ── 2. HISTOLOGY PHOTOS ───────────────────────────── */}
                                                                        <div className="row col-lg-12 mt-4 upload-imgs">

                                                                            <div className="col-lg-12 align-items-start justify-content-between upload-img-section pe-0 me-0">
                                                                                <label className="form_label col-12">HISTOLOGY PHOTOS</label>



                                                                            </div>


                                                                            <div className="mt-2 mb-0 pe-0 ">
                                                                                <div className="d-flex justify-content-between histology-photo-section">
                                                                                    <p className="case-type-text">PNG, JPEG, JPG Files Only</p>
                                                                                    <p className="mt-0 mb-0 text-muted file-format">Note: Max File size: 20 MB, Max files: 20 | Formats: PNG, JPEG, JPG</p>
                                                                                </div>
                                                                                <div className="d-flex justify-content-start col-lg-12 histology-photo-section gap-2 ">

                                                                                    <div className="mb-1 mt-2 input-field deep-zoom-styles">
                                                                                        {/* OME Upload box */}
                                                                                        <div className="upload-image">
                                                                                            <div className="file_upload add-box">
                                                                                                <input
                                                                                                    type="file"
                                                                                                    id="omefile-upload"
                                                                                                    accept={".jpeg,.jpg,.png"}
                                                                                                    className="file-input"
                                                                                                    // mgetGeoTiffDimensionsultiple
                                                                                                    multiple
                                                                                                    disabled={isRestricted}
                                                                                                    onChange={(e) => handleFileChange(e, "histologyJpeg")}
                                                                                                    style={{ display: "none" }}
                                                                                                />
                                                                                                <label htmlFor="omefile-upload" className="Add-btn d-flex align-items-center justify-content-center flex-column">
                                                                                                    <p className="mb-0">
                                                                                                        <span className="material-symbols-outlined plus-icon">add</span>
                                                                                                    </p>
                                                                                                    ADD
                                                                                                </label>
                                                                                            </div>

                                                                                        </div>

                                                                                        {imagesUrls &&
                                                                                            Object.keys(imagesUrls).length > 0 &&
                                                                                            Object.keys(imagesUrls).filter(file => getExtension(imagesUrls[file].name) === ".jpeg,.jpg,.png").map((item, key) => (

                                                                                                <div className="thumb-box" key={key}>
                                                                                                    <div
                                                                                                        className="thumb-img cursor-pointer"
                                                                                                        onClick={() => handlePopupImage(item?.sourcepath ? `${imageCloudfront}${item?.sourcepath?.replace(/ /g, '%20')}` : deepZoom)}
                                                                                                    >



                                                                                                        <img
                                                                                                            src={item?.thumbnailUrl ? `${imageCloudfront}${item?.thumbnailUrl?.replace(/ /g, '%20')}?auto=compress,format` : deepZoom}
                                                                                                            alt="uploaded"
                                                                                                        />

                                                                                                        <span
                                                                                                            className="icon-close"
                                                                                                            onClick={(e) => {
                                                                                                                e.stopPropagation();
                                                                                                                handleImageDelete(e, item)
                                                                                                            }}
                                                                                                        >
                                                                                                            ×
                                                                                                        </span>
                                                                                                    </div>

                                                                                                </div>
                                                                                            ))}





                                                                                        {editUser?.files?.length > 0 &&
                                                                                            editUser.files.filter(file => getExtension(file?.originalFilename) === ".jpeg,.jpg,.png").map((file, key) => {
                                                                                                const imagePath = `${imageCloudfront}${file?.sourcepath?.replace(/ /g, '%20')
                                                                                                    }?auto=compress,format`;
                                                                                                const showFailed = file.uploadStatus === "FAILED" || isStaleUpload(file) || checkStuckUploads(file);
                                                                                                const isSelected = selectedFiles.some(f => f.fileid === file.fileid);

                                                                                                return (
                                                                                                    <div
                                                                                                        className={`thumb-box${isSelectMode && isSelected ? ' file-selected' : ''}`}
                                                                                                        key={key}
                                                                                                        style={isSelectMode ? { cursor: 'pointer' } : {}}
                                                                                                        onClick={() => { if (isSelectMode) toggleFileSelection(file.fileid, 'ome', file); }}
                                                                                                    >
                                                                                                        <div
                                                                                                            className="thumb-img cursor-pointer"

                                                                                                            onClick={(e) => {
                                                                                                                if (isSelectMode) return;
                                                                                                                if (
                                                                                                                    file.allow &&
                                                                                                                    (!file.dzistatus || String(file.dzistatus).toUpperCase() !== "COMPLETED")
                                                                                                                ) {


                                                                                                                    e.preventDefault();
                                                                                                                    console.log("⏳ DZI still processing — preview disabled.");
                                                                                                                    return; // stop further actions
                                                                                                                }
                                                                                                                // handlePopupImage(imagePath)
                                                                                                                console.log("[JPEG Click] file:", file);
                                                                                                                console.log("[JPEG Click] imageCloudfront:", imageCloudfront);
                                                                                                                console.log("[JPEG Click] file.dziUrl:", file.dziUrl, "| file.dzistatus:", file.dzistatus);
                                                                                                                console.log("[JPEG Click] file.sourcepath:", file.sourcepath, "| width:", file.width, "| height:", file.height);

                                                                                                                setPopupOpen(true);
                                                                                                                setImageDimensions({ width: file.width, height: file.height });

                                                                                                                let path = file.dziUrl || "";
                                                                                                                if (path.startsWith("/")) path = path.slice(1);
                                                                                                                let isDziURL = path.includes("output.dzi");
                                                                                                                console.log("[JPEG Click] path after strip:", path, "| isDziURL:", isDziURL);
                                                                                                                if (isDziURL) {
                                                                                                                    path = `${path}_files/`;
                                                                                                                    console.log("[JPEG Click] DZI → setDziUrl:", imageCloudfront + path);
                                                                                                                    setDziUrl(imageCloudfront + path);
                                                                                                                } else {
                                                                                                                    console.log("[JPEG Click] non-DZI → setDziUrl:", imagePath);
                                                                                                                    setDziUrl(imagePath);
                                                                                                                }

                                                                                                                setDziUrlFile(file?.originalFilename ? file?.originalFilename : file.filename)
                                                                                                                setDZIPopupImage(imageCloudfront + file.sourcepath);
                                                                                                                handlePopupload(e);

                                                                                                                const viewableFiles = (editUser?.files || []).filter(f =>
                                                                                                                    f.uploadStatus === "COMPLETED" &&
                                                                                                                    getExtension(f?.originalFilename) === ".jpeg,.jpg,.png" &&
                                                                                                                    (!f.allow || String(f.dzistatus).toUpperCase() === "COMPLETED")
                                                                                                                );
                                                                                                                const clickedIdx = viewableFiles.findIndex(f =>
                                                                                                                    (f.fileid && f.fileid === file.fileid) ||
                                                                                                                    (f.sourcepath === file.sourcepath)
                                                                                                                );
                                                                                                                setDziImageList(viewableFiles);
                                                                                                                setDziCurrentIndex(clickedIdx >= 0 ? clickedIdx : 0);

                                                                                                            }}
                                                                                                        >

                                                                                                            {/* {(file.uploadStatus === "INPROGRESS" &&
                                                                                                        <span className="img_view deep-zzom-ope-icon progessIcon">
                                                                                                            <img src={progessIcon} alt="Upload in progress" />
                                                                                                        </span>
                                                                                                     )}  */}

                                                                                                            {isSelectMode && (
                                                                                                                <input
                                                                                                                    type="checkbox"
                                                                                                                    className="select-file-checkbox"
                                                                                                                    checked={isSelected}
                                                                                                                    onChange={() => toggleFileSelection(file.fileid, 'ome', file)}
                                                                                                                    onClick={e => e.stopPropagation()}
                                                                                                                />
                                                                                                            )}

                                                                                                            <img src={


                                                                                                                //  file?.sourcepath ? imageCloudfront?.replace(/\/$/, "") + file?.thumbnailUrl + "?auto=compress,format&width=150" : deepZoom
                                                                                                                file?.thumbnailUrl ? imageCloudfront?.replace(/\/$/, "") + file?.thumbnailUrl + "?auto=compress,format&width=150" : (

                                                                                                                    file?.sourcepath ? `${imageCloudfront}${file?.sourcepath && file?.sourcepath?.replace(/ /g, "%20")}?auto=compress,format` : deepZoom
                                                                                                                )}

                                                                                                                onError={(e) => {
                                                                                                                    e.currentTarget.onerror = null; // Prevent looping
                                                                                                                    e.currentTarget.src = deepZoom; // your default image path
                                                                                                                }}
                                                                                                                alt={file?.originalFilename} />

                                                                                                            {showFailed && (
                                                                                                                <Tooltip
                                                                                                                    title="Upload failed due to network interruption. Please delete and try again."
                                                                                                                    placement="top"
                                                                                                                    arrow
                                                                                                                >
                                                                                                                    <span className="material-symbols-outlined img_view errorIcon">
                                                                                                                        <img src={errorSvg} alt="Failed" />
                                                                                                                    </span>
                                                                                                                </Tooltip>
                                                                                                            )}



                                                                                                            {file?.uploadStatus === "INPROGRESS" && !showFailed && (
                                                                                                                <span className="material-symbols-outlined img_view loadingIcon">
                                                                                                                    <img src={loadingIcon} alt="Upload in progress" />
                                                                                                                </span>
                                                                                                            )}

                                                                                                            {file?.uploadStatus === "COMPLETED" && (file?.dzistatus === "INPROGRESS" || !file?.dzistatus) && (
                                                                                                                <Tooltip
                                                                                                                    title={isDziStuck(file) ? `DZI processing stuck (${getDziPendingHours(file)}h). Delete and re-upload the file.` : "Converting to Deep Zoom format..."}
                                                                                                                    placement="top"
                                                                                                                    arrow
                                                                                                                >
                                                                                                                    <span className="material-symbols-outlined img_view loadingIcon" style={isDziStuck(file) ? { filter: "hue-rotate(200deg)", cursor: "help" } : {}}>
                                                                                                                        <img src={progessIcon} alt="Processing" />
                                                                                                                    </span>
                                                                                                                </Tooltip>
                                                                                                            )}




                                                                                                            {!isSelectMode && file?.dzistatus === "COMPLETED" && (
                                                                                                                <span
                                                                                                                    title="Share Image"
                                                                                                                    style={{ position: "absolute", top: "4px", right: "28px", cursor: "pointer", zIndex: 10, background: "rgba(255,255,255,0.85)", borderRadius: "50%", width: "22px", height: "22px", display: "flex", alignItems: "center", justifyContent: "center" }}
                                                                                                                    onClick={(e) => {
                                                                                                                        e.stopPropagation();
                                                                                                                        handleShareClick(file);
                                                                                                                    }}
                                                                                                                >
                                                                                                                    <span className="material-symbols-outlined" style={{ fontSize: "13px", color: "#1E222B", fontWeight: 700 }}>share</span>
                                                                                                                </span>
                                                                                                            )}
                                                                                                            {!isSelectMode && (
                                                                                                                <span
                                                                                                                    className="icon-close"
                                                                                                                    onClick={(e) => {
                                                                                                                        e.stopPropagation();
                                                                                                                        handleImageFileDelete(e, file, key, "ome")
                                                                                                                    }
                                                                                                                    }
                                                                                                                >
                                                                                                                    ×
                                                                                                                </span>
                                                                                                            )}

                                                                                                        </div>
                                                                                                        {/* <p className="thumb-name text-truncate small mb-0">
                                                                                                {item.filename}
                                                                                            </p> */}
                                                                                                    </div>
                                                                                                );
                                                                                            })
                                                                                        }



                                                                                    </div>


                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div className="row col-lg-12 mt-0 upload-imgs">


                                                                            <div className="d-flex justify-content-between tiff-files-section">
                                                                                <p className="case-type-text">TIFF Files</p>
                                                                                <p className="mt-0 mb-0 text-muted file-format">Note: Max File size: 2GB, Max files: 10 | Formats: TIF,TIFF</p>
                                                                            </div>



                                                                            <div className="d-flex justify-content-start col-lg-12 histology-photo-section gap-2">

                                                                                <div className="mb-3 mt-2 input-field deep-zoom-styles">
                                                                                    {/* OME Upload box */}
                                                                                    <div className="upload-image">
                                                                                        <div className="file_upload add-box">
                                                                                            <input
                                                                                                type="file"
                                                                                                id="omefile-upload-2"
                                                                                                accept={".tif,.tiff"}
                                                                                                className="file-input"
                                                                                                disabled={isRestricted}
                                                                                                // mgetGeoTiffDimensionsultiple

                                                                                                multiple
                                                                                                onChange={(e) => handleFileChange(e, "histologyTiff")}
                                                                                                style={{ display: "none" }}
                                                                                            />
                                                                                            <label htmlFor="omefile-upload-2" className="Add-btn d-flex align-items-center justify-content-center flex-column">
                                                                                                <p className="mb-0">
                                                                                                    <span className="material-symbols-outlined plus-icon">add</span>
                                                                                                </p>
                                                                                                ADD
                                                                                            </label>
                                                                                        </div>

                                                                                    </div>
                                                                                    {imagesUrls &&
                                                                                        Object.keys(imagesUrls).length > 0 &&
                                                                                        Object.keys(imagesUrls).filter((file) => getExtension(imagesUrls[file].name) === ".tif,.tiff").map((item, key) => (
                                                                                            <div className={`upload_images d-flex gap-2 align-items-start ${!item?.thumbnailUrl ? 'upload-static-img' : ''}`} key={key}>
                                                                                                <div className="img">
                                                                                                    {item?.thumbnailUrl}
                                                                                                    {/* <p className="text-truncate small mb-0">{imagesUrls[item].name}</p> */}
                                                                                                    <span className={`default-img ${!item?.thumbnailUrl ? 'default-static-img' : ''}`}><img src={item?.thumbnailUrl ? `${imageCloudfront}${item?.thumbnailUrl?.replace(/ /g, '%20')}?auto=compress,format` : deepZoom} alt="" /></span>

                                                                                                </div>

                                                                                                <span
                                                                                                    onClick={(e) => handleImageDelete(e, item)}
                                                                                                    className="icon-close"
                                                                                                >
                                                                                                    x
                                                                                                </span>
                                                                                            </div>
                                                                                        ))}

                                                                                    {editUser?.files?.length > 0 &&
                                                                                        editUser.files.filter(file => getExtension(file?.originalFilename) === ".tif,.tiff").map((file, key) => {
                                                                                            const showFailed = file.uploadStatus === "FAILED" || isStaleUpload(file) || checkStuckUploads(file);
                                                                                            const isSelected = selectedFiles.some(f => f.fileid === file.fileid);



                                                                                            return (
                                                                                                <div
                                                                                                    className={`upload_images d-flex gap-2 align-items-start ${!file?.thumbnailUrl ? 'upload-static-img' : ''}${isSelectMode && isSelected ? ' file-selected' : ''}`}
                                                                                                    key={key}
                                                                                                    style={isSelectMode ? { cursor: 'pointer' } : {}}
                                                                                                    onClick={() => { if (isSelectMode) toggleFileSelection(file.fileid, 'ome', file); }}
                                                                                                >
                                                                                                    <div
                                                                                                        className="img cursor-pointer"
                                                                                                        onClick={(e) => {
                                                                                                            if (isSelectMode) return;

                                                                                                            console.log("[TIFF Click] file:", file);
                                                                                                            console.log("[TIFF Click] imageCloudfront:", imageCloudfront);
                                                                                                            console.log("[TIFF Click] file.dziUrl:", file.dziUrl, "| file.dzistatus:", file.dzistatus);
                                                                                                            console.log("[TIFF Click] file.sourcepath:", file.sourcepath, "| width:", file.width, "| height:", file.height);

                                                                                                            if (file?.dzistatus == "COMPLETED") {
                                                                                                                setPopupOpen(true);
                                                                                                                setImageDimensions({ width: file.width, height: file.height });

                                                                                                                let path = file.dziUrl || "";
                                                                                                                if (path.startsWith("/")) path = path.slice(1);
                                                                                                                let isDziURL = path.includes("output.dzi");
                                                                                                                console.log("[TIFF Click] path after strip:", path, "| isDziURL:", isDziURL);
                                                                                                                if (isDziURL) {
                                                                                                                    path = `${path}_files/`;
                                                                                                                }

                                                                                                                console.log("[TIFF Click] setDziUrl:", imageCloudfront + path);
                                                                                                                setDziUrl(imageCloudfront + path);
                                                                                                                setDziUrlFile(file?.originalFilename ? file?.originalFilename : file.filename)
                                                                                                                setDZIPopupImage(imageCloudfront + file.sourcepath);
                                                                                                                handlePopupload(e);

                                                                                                                const viewableFiles = (editUser?.files || []).filter(f =>
                                                                                                                    f.uploadStatus === "COMPLETED" &&
                                                                                                                    getExtension(f?.originalFilename) === ".tif,.tiff" &&
                                                                                                                    String(f.dzistatus).toUpperCase() === "COMPLETED"
                                                                                                                );
                                                                                                                const clickedIdx = viewableFiles.findIndex(f =>
                                                                                                                    (f.fileid && f.fileid === file.fileid) ||
                                                                                                                    (f.sourcepath === file.sourcepath)
                                                                                                                );
                                                                                                                setDziImageList(viewableFiles);
                                                                                                                setDziCurrentIndex(clickedIdx >= 0 ? clickedIdx : 0);
                                                                                                            }

                                                                                                        }}
                                                                                                    >
                                                                                                        {isSelectMode && (
                                                                                                            <input
                                                                                                                type="checkbox"
                                                                                                                className="select-file-checkbox"
                                                                                                                checked={isSelected}
                                                                                                                onChange={() => toggleFileSelection(file.fileid, 'ome', file)}
                                                                                                                onClick={e => e.stopPropagation()}
                                                                                                            />
                                                                                                        )}

                                                                                                        <span className={`default-img ${!file?.thumbnailUrl ? 'default-static-img' : ''}`}><img src={file?.thumbnailUrl ? `${imageCloudfront?.replace(/\/$/, "")}${file?.thumbnailUrl.replace(/ /g, '%20')}?auto=compress,format&width=150` : deepZoom} alt={file?.originalFilename} /></span>



                                                                                                        {showFailed && (
                                                                                                            <Tooltip
                                                                                                                title="Upload failed due to network interruption. Please delete and try again."
                                                                                                                placement="top"
                                                                                                                arrow
                                                                                                            >
                                                                                                                <span className="material-symbols-outlined img_view errorIcon">
                                                                                                                    <img src={errorSvg} alt="Failed" />
                                                                                                                </span>
                                                                                                            </Tooltip>
                                                                                                        )}

                                                                                                        {file?.uploadStatus === "INPROGRESS" && !showFailed && (
                                                                                                            <span className="material-symbols-outlined img_view loadingIcon">
                                                                                                                <img src={loadingIcon} alt="Upload in progress" />
                                                                                                            </span>
                                                                                                        )}

                                                                                                        {file?.uploadStatus === "COMPLETED" && (file?.dzistatus === "INPROGRESS" || !file?.dzistatus) && (
                                                                                                            <Tooltip
                                                                                                                title={isDziStuck(file) ? `DZI processing stuck (${getDziPendingHours(file)}h). Delete and re-upload the file.` : "Converting to Deep Zoom format..."}
                                                                                                                placement="top"
                                                                                                                arrow
                                                                                                            >
                                                                                                                <span className="material-symbols-outlined img_view loadingIcon" style={isDziStuck(file) ? { filter: "hue-rotate(200deg)", cursor: "help" } : {}}>
                                                                                                                    <img src={progessIcon} alt="Processing" />
                                                                                                                </span>
                                                                                                            </Tooltip>
                                                                                                        )}
                                                                                                        {!isSelectMode && file?.uploadStatus === "COMPLETED" && file?.dzistatus === "COMPLETED" && (
                                                                                                            <span
                                                                                                                title="Share Image"
                                                                                                                style={{ position: "absolute", top: "4px", right: "28px", cursor: "pointer", zIndex: 10, background: "rgba(255,255,255,0.85)", borderRadius: "50%", width: "22px", height: "22px", display: "flex", alignItems: "center", justifyContent: "center" }}
                                                                                                                onClick={(e) => {
                                                                                                                    e.stopPropagation();
                                                                                                                    handleShareClick(file);
                                                                                                                }}
                                                                                                            >
                                                                                                                <span className="material-symbols-outlined" style={{ fontSize: "13px", color: "#1E222B", fontWeight: 700 }}>share</span>
                                                                                                            </span>
                                                                                                        )}
                                                                                                        {!isSelectMode && (showFailed || (file?.uploadStatus === "COMPLETED" && file?.dzistatus === "COMPLETED") || isDziStuck(file)) &&
                                                                                                            <span
                                                                                                                className="icon-close"
                                                                                                                onClick={(e) => {
                                                                                                                    e.stopPropagation();
                                                                                                                    handleImageFileDelete(e, file, key, "ome");
                                                                                                                }}
                                                                                                            >
                                                                                                                ×
                                                                                                            </span>}

                                                                                                    </div>



                                                                                                </div>
                                                                                            )
                                                                                        })}

                                                                                </div>


                                                                            </div>
                                                                        </div>
                                                                    </div>




                                                                    <div>
                                                                        {imageErrorFiles && imageErrorFiles.length > 0 && imageErrorFiles?.map((item, key) => {

                                                                            return (
                                                                                <div className="upload_images" key={key}>
                                                                                    <div className="img">
                                                                                        <img src={item?.url} />
                                                                                        <p>{item?.error} </p>
                                                                                    </div>
                                                                                    <span onClick={(e) => handleImageErrorDelete(e, item)} className="material-symbols-outlined icon"> delete </span>
                                                                                </div>

                                                                            )
                                                                        })}
                                                                    </div>

                                                                </div>


                                                                <div className="row col-lg-5 col-md-12 col-12 video-edit-section answer-with-explanation">

                                                                    <b className="mb-2 answer-text">Answer with Explanation</b>

                                                                    <div className="col-lg-12 col-md-12">
                                                                        <div className="mb-3 input-field youtube-input-resp">
                                                                            <label className="form_label">YOUTUBE VIDEO URL</label>
                                                                            <input id="youtube" name="youtube" placeholder="Enter Youtube URL" type="text" className="form-control" aria-invalid="false" onChange={(e) => handleChange(e)} value={editUser?.youtube} />
                                                                            <span id="youtube-error" className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{youtubeError}</span>
                                                                        </div>
                                                                    </div>


                                                                    <div className="col-lg-12 col-md-12">
                                                                        {
                                                                            getYouTubeVideoId(editUser?.youtube) && (
                                                                                <div style={{ marginTop: "10px" }}>
                                                                                    <img
                                                                                        src={`https://img.youtube.com/vi/${getYouTubeVideoId(
                                                                                            editUser?.youtube
                                                                                        )}/0.jpg`}
                                                                                        alt="YouTube Thumbnail"
                                                                                        style={{
                                                                                            width: "100%",
                                                                                            maxWidth: "300px",
                                                                                            cursor: "pointer",
                                                                                        }}
                                                                                        onClick={() => setShowVideoPopup(true)}
                                                                                    />
                                                                                    <p className="d-flex justify-content-start align-items-center gap-2"
                                                                                        style={{ cursor: "pointer" }}
                                                                                        onClick={() => setShowVideoPopup(true)}
                                                                                    >
                                                                                        <span className="material-symbols-outlined">
                                                                                            smart_display
                                                                                        </span> <span className="pre-vid-txt">Preview Video</span>
                                                                                    </p>
                                                                                </div>)
                                                                        }

                                                                        {showVideoPopup && (
                                                                            <div
                                                                                style={{
                                                                                    position: "fixed",
                                                                                    top: 0,
                                                                                    left: 0,
                                                                                    width: "100%",
                                                                                    height: "100%",
                                                                                    backgroundColor: "rgba(0,0,0,0.8)",
                                                                                    zIndex: 1000,
                                                                                    display: "flex",
                                                                                    alignItems: "center",
                                                                                    justifyContent: "center",
                                                                                }}
                                                                                onClick={() => setShowVideoPopup(false)}
                                                                            >
                                                                                <div style={{ position: "relative", width: "80%", maxWidth: "800px" }}>
                                                                                    <iframe
                                                                                        width="100%"
                                                                                        height="450"
                                                                                        src={`https://www.youtube.com/embed/${getYouTubeVideoId(
                                                                                            editUser?.youtube
                                                                                        )}`}
                                                                                        frameBorder="0"
                                                                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                                                                        allowFullScreen
                                                                                        title="Video Preview"
                                                                                    ></iframe>

                                                                                    <button
                                                                                        className="dz_close"
                                                                                        onClick={() => setShowVideoPopup(false)}
                                                                                        style={{
                                                                                            position: "absolute",
                                                                                            top: 10,
                                                                                            right: 10,
                                                                                            cursor: "pointer",
                                                                                            borderRadius: "6px",
                                                                                        }}
                                                                                    >
                                                                                        <span className="material-symbols-outlined">close</span>
                                                                                    </button>

                                                                                </div>
                                                                            </div>
                                                                        )}
                                                                    </div>

                                                                    <style>
                                                                        {
                                                                            `
                                                                textarea.form-control {
                                                                min-height: calc(6.5em + .75rem + 2px) !important;}
                                                                `
                                                                        }
                                                                    </style>
                                                                    <div className="col-lg-12 col-md-12 answer-input-resp">
                                                                        <div className="mb-3 input-field">
                                                                            <label className="form_label">EXPLANATION
                                                                                {/* {id && <span className="required">*</span>} */}
                                                                            </label>
                                                                            {/* <Editor name="clinicalhistory" value={editUser?.clinicalhistory} onChange={(e) => onDescriptionChange(e)} /> */}

                                                                            <Editor name="editUser?.explanation" placeholder="Enter Explanation" className="edit-case-explanation" onChange={(e) => onExplanationChange(e)} value={editUser?.explanation} />

                                                                            {/* <textarea id="explanation" name="explanation" placeholder="Enter Explanation" type="text" className="form-control" aria-invalid="false" onChange={(e) => handleChange(e)} value={editUser?.explanation}
                                                                        rows={5}
                                                                        cols={3}>
                                                                    </textarea> */}
                                                                            <span id="explanation-error" className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{explanationError}</span>
                                                                        </div>
                                                                    </div>


                                                                    <div className="col-lg-12 col-md-12 answers-input">
                                                                        <div className="mb-3 input-field">
                                                                            <label className="form_label">Answer(1 point)
                                                                                {/* {id && <span className="required">*</span>} */}
                                                                            </label>
                                                                            {filteredOptionsMap?.answer1 && <Select
                                                                                className="select"
                                                                                isMulti={false}
                                                                                placeholder="Type Answer and Select"
                                                                                onChange={(option) => handleSelectChange(option, "answer1")}
                                                                                onInputChange={(value) => handleInputChange(value, "answer1")}
                                                                                options={filteredOptionsMap?.answer1}
                                                                                isClearable
                                                                                value={editUser?.answer1 || null}
                                                                                components={customComponents}
                                                                            />}

                                                                            <span id="answer1-error" className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{answer1Error}</span>
                                                                        </div>
                                                                    </div>

                                                                    <div className="col-lg-12 col-md-12 answers-input">
                                                                        <div className="mb-3 input-field">
                                                                            <label className="form_label">Answer(1 point)
                                                                                {/* {id && <span className="required">*</span>} */}
                                                                            </label>
                                                                            {filteredOptionsMap?.answer11 && <Select
                                                                                className="select"
                                                                                isMulti={false}
                                                                                placeholder="Type Answer and Select"
                                                                                onChange={(option) => handleSelectChange(option, "answer11")}
                                                                                onInputChange={(value) => handleInputChange(value, "answer11")}
                                                                                options={filteredOptionsMap?.answer11}
                                                                                isClearable
                                                                                value={editUser?.answer11 || null}
                                                                                components={customComponents}
                                                                            />}


                                                                        </div>
                                                                    </div>

                                                                    <div className="col-lg-12 col-md-12 answers-input">
                                                                        <div className="mb-3 input-field">
                                                                            <label className="form_label">Answer(0.5 point) {id && <span className="required"></span>}</label>
                                                                            {filteredOptionsMap?.answer2 && <Select
                                                                                className="select"
                                                                                isMulti={false}
                                                                                placeholder="Type Answer and Select"
                                                                                onChange={(option) => handleSelectChange(option, "answer2")}
                                                                                onInputChange={(value) => handleInputChange(value, "answer2")}
                                                                                options={filteredOptionsMap?.answer2}
                                                                                isClearable
                                                                                value={editUser?.answer2 || null}
                                                                                components={customComponents}
                                                                            />}

                                                                            <span id="answer2-error" className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{answer2Error}</span>


                                                                        </div>
                                                                    </div>
                                                                    <div className="col-lg-12 col-md-12 d-flex justify-content-end mb-2">
                                                                        <Tooltip title="Create a new answer to use in the dropdowns above" placement="top">
                                                                            <button
                                                                                type="button"
                                                                                id="submit-button"
                                                                                className="create-quiz-btn border-0"
                                                                                // className="btn btn-primary btn-sm"
                                                                                // title="Create a new answer to use in the dropdowns above"
                                                                                onClick={() => setShowPopup(true)}
                                                                                style={{ borderRadius: '6px', padding: '5px 14px', fontWeight: 600 }}
                                                                            >
                                                                                + Add Answer
                                                                            </button>
                                                                        </Tooltip>
                                                                    </div>
                                                                    {editUser?.status === "ACTIVE" && <>

                                                                        {/* <hr /> */}
                                                                        <div className="col-lg-12 col-md-12">
                                                                            <div className="mb-3 input-field">

                                                                                <label className="form_label">Add Modules
                                                                                    {/* {id && <span className="required">*</span>} */}
                                                                                </label>

                                                                                <div className="mb-3 input-field tags-mob-wid">


                                                                                    <div style={{ width: "100%", maxWidth: "600px" }}>
                                                                                        {/* <label style={{ fontWeight: "bold" }}>TAGS</label> */}
                                                                                        <Select
                                                                                            isMulti
                                                                                            options={moduleOptions}
                                                                                            value={selectedModules}
                                                                                            onChange={handleChangeModules}
                                                                                            placeholder="Select modules"
                                                                                            styles={{
                                                                                                multiValue: (base) => ({
                                                                                                    ...base,
                                                                                                    backgroundColor: "#e0e0e0",
                                                                                                    borderRadius: "6px",
                                                                                                    padding: "2px 6px",
                                                                                                }),
                                                                                            }}
                                                                                        />

                                                                                    </div>




                                                                                    {/* <span id="tag-error" className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{tagError}</span> */}
                                                                                </div>

                                                                            </div>
                                                                        </div></>}

                                                                    {editUser?.caseModules?.length > 0 && <>
                                                                        {/* <hr /> */}



                                                                        <div className="col-lg-12 col-md-12 answers-input">
                                                                            <div className="mb-3 input-field">
                                                                                <b className="mb-2 answer-text">Assigned Modules</b>

                                                                                <ul className="mt-2 assigned-modules-list">
                                                                                    {editUser?.caseModules.map((module, index) => (
                                                                                        <li className="nav-item" key={index}>{module}</li>
                                                                                    ))}
                                                                                </ul>


                                                                            </div>
                                                                        </div>
                                                                    </>
                                                                    }

                                                                </div>



                                                            </div>




                                                        </div>
                                                        <div className="line">

                                                        </div>
                                                    </div>

                                                    <div className="row">
                                                        <div className="col-md-12 d-flex gap-2" >

                                                            {id && editUser?.status == "INACTIVE" && (
                                                                <button
                                                                    id="submit-button"
                                                                    className="fill-btn-style create-quiz-outline-btn border-0"
                                                                    type="button"
                                                                    style={{ cursor: loadingButton === "INACTIVE" ? "not-allowed" : "pointer" }}
                                                                    onClick={(e) => handleUpdate(e, "INACTIVE")}
                                                                >
                                                                    {loadingButton && (
                                                                        <img src={rotate_right} className="loading-icon me-2" id="loginPwdLoading" alt="loading" />
                                                                    )}
                                                                    Save as draft
                                                                </button>
                                                            )}



                                                            {/* {id && <button id="submit-button" className={editUser?.files && editUser?.files.length > 0 ? "fill-btn-style create-quiz-btn border-0" : "fill-btn-style create-quiz-btn border-0 disabled"} type="button" onClick={e => handleUpdate(e, 'ACTIVE')} 
                                                    disabled={editUser?.files && editUser?.files.length > 0 ?  false : true}
                                                        >Save
                                                    </button>} */}

                                                            {completedFiles &&
                                                                editUser?.files &&
                                                                completedFiles.length === editUser?.files.length &&
                                                                editUser?.status == "INACTIVE" && (
                                                                    <button
                                                                        id="submit-button"
                                                                        className="fill-btn-style create-quiz-btn border-0"
                                                                        type="button"
                                                                        style={{ cursor: loadingButton === "ACTIVE" ? "not-allowed" : "pointer" }}
                                                                        onClick={(e) => {
                                                                            const isValid = formvalidation();
                                                                            if (isValid) {
                                                                                handleUpdate(e, "ACTIVE");
                                                                            } else {
                                                                                toast.error("Please fill all required fields", {
                                                                                    position: "bottom-center",
                                                                                    autoClose: 2000,
                                                                                    hideProgressBar: false,
                                                                                    closeOnClick: true,
                                                                                    pauseOnHover: true,
                                                                                    draggable: true,
                                                                                    progress: undefined,
                                                                                    theme: "light",
                                                                                });
                                                                            }
                                                                        }}
                                                                        disabled={loadingButton === "ACTIVE"}
                                                                    >
                                                                        {loadingButton === "ACTIVE" && (
                                                                            <img src={rotate_right} className="loading-icon me-2" id="loginPwdLoading" alt="loading" />
                                                                        )}
                                                                        Save
                                                                    </button>
                                                                )}



                                                            {(editUser?.status == "ACTIVE") &&
                                                                <button
                                                                    id="submit-button"
                                                                    type="button"
                                                                    className="fill-btn-style create-quiz-btn border-0"
                                                                    style={{
                                                                        cursor: isLoading ? "not-allowed" : "pointer"
                                                                    }}
                                                                    onClick={(e) => handleUpdate(e, "ACTIVE")}
                                                                >
                                                                    {isLoading && (
                                                                        <img
                                                                            src={rotate_right}
                                                                            className="loading-icon"
                                                                            id="loginPwdLoading"
                                                                            alt="loading"
                                                                        />
                                                                    )}
                                                                    Save
                                                                </button>
                                                            }


                                                            {id === undefined && <button
                                                                id="submit-button"
                                                                type="button"
                                                                style={{
                                                                    cursor: isLoading ? "not-allowed" : "pointer"
                                                                }}
                                                                className="fill-btn-style create-quiz-btn border-0"
                                                                onClick={(e) => handleAddUser(e, "INACTIVE")}
                                                            >
                                                                {isLoading && (
                                                                    <img
                                                                        src={rotate_right}
                                                                        className="loading-icon"
                                                                        id="loginPwdLoading"
                                                                        alt="loading"
                                                                    />
                                                                )}
                                                                Save as draft
                                                            </button>
                                                            }

                                                        </div>
                                                        {msg && <span id="success-msg" className="errormsg" style={{ fontWeight: 'bold', color: 'green' }}>{msg}</span>}
                                                    </div>
                                                </>
                                            ) : (
                                                loading &&
                                                <div className="form-block" id="loading-block">
                                                    <div className="tab-content p-3 text-muted">
                                                        <div className="tab-pane active show" id="home1" role="tabpanel">
                                                            <div className="row">
                                                                <Loader />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                </div>
                            </div>
                        </div>
                        <Footer id="footer" />
                    </div>

                }


                {showImagePopup && (
                    <div
                        style={{
                            position: "fixed",
                            top: 0, left: 0,
                            width: "100%", height: "100%",
                            backgroundColor: "rgba(0,0,0,0.88)",
                            zIndex: 1003,
                            display: "flex",
                            flexDirection: "column",
                        }}
                        onClick={() => setShowImagePopup(false)}
                    >
                        {/* Header */}
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                padding: "0 20px",
                                height: "52px",
                                flexShrink: 0,
                                background: "linear-gradient(135deg, #091918 0%, #215250 100%)",
                                borderBottom: "1px solid rgba(255,255,255,0.08)",
                                boxShadow: "0 2px 12px rgba(0,0,0,0.4)",
                            }}
                            onClick={(e) => e.stopPropagation()}
                        >
                            {/* Left spacer */}
                            <div style={{ width: "120px" }} />

                            {/* Prev / Counter / Next — only when list has multiple */}
                            {clinicalPopupList.length > 1 ? (
                                <div style={{
                                    display: "flex",
                                    alignItems: "center",
                                    background: "rgba(255,255,255,0.07)",
                                    border: "1px solid rgba(255,255,255,0.15)",
                                    borderRadius: "30px",
                                    padding: "3px",
                                }}>
                                    <button
                                        onClick={() => navigateClinicalImage(clinicalPopupIndex - 1)}
                                        disabled={clinicalPopupIndex === 0}
                                        title="Previous image (←)"
                                        style={{
                                            border: "none",
                                            background: clinicalPopupIndex === 0 ? "transparent" : "rgba(255,255,255,0.1)",
                                            color: clinicalPopupIndex === 0 ? "rgba(255,255,255,0.25)" : "#ffffff",
                                            cursor: clinicalPopupIndex === 0 ? "not-allowed" : "pointer",
                                            width: "34px", height: "34px",
                                            borderRadius: "50%",
                                            display: "flex", alignItems: "center", justifyContent: "center",
                                            flexShrink: 0,
                                        }}
                                    >
                                        <span className="material-symbols-outlined" style={{ fontSize: "20px", lineHeight: 1 }}>chevron_left</span>
                                    </button>
                                    <span style={{
                                        display: "flex", alignItems: "center", gap: "4px",
                                        padding: "0 12px", fontSize: "13px", fontWeight: "600",
                                        userSelect: "none", whiteSpace: "nowrap",
                                    }}>
                                        <span style={{ color: "#EA7F4A", fontWeight: "700" }}>{clinicalPopupIndex + 1}</span>
                                        <span style={{ color: "rgba(255,255,255,0.35)", fontSize: "11px", margin: "0 1px" }}>/</span>
                                        <span style={{ color: "rgba(255,255,255,0.6)" }}>{clinicalPopupList.length}</span>
                                    </span>
                                    <button
                                        onClick={() => navigateClinicalImage(clinicalPopupIndex + 1)}
                                        disabled={clinicalPopupIndex === clinicalPopupList.length - 1}
                                        title="Next image (→)"
                                        style={{
                                            border: "none",
                                            background: clinicalPopupIndex === clinicalPopupList.length - 1 ? "transparent" : "rgba(255,255,255,0.1)",
                                            color: clinicalPopupIndex === clinicalPopupList.length - 1 ? "rgba(255,255,255,0.25)" : "#ffffff",
                                            cursor: clinicalPopupIndex === clinicalPopupList.length - 1 ? "not-allowed" : "pointer",
                                            width: "34px", height: "34px",
                                            borderRadius: "50%",
                                            display: "flex", alignItems: "center", justifyContent: "center",
                                            flexShrink: 0,
                                        }}
                                    >
                                        <span className="material-symbols-outlined" style={{ fontSize: "20px", lineHeight: 1 }}>chevron_right</span>
                                    </button>
                                </div>
                            ) : (
                                <div />
                            )}

                            {/* Close */}
                            <div style={{ width: "120px", display: "flex", justifyContent: "flex-end" }}>
                                <button
                                    className="dz_close"
                                    onClick={() => setShowImagePopup(false)}
                                    title="Close"
                                    style={{
                                        border: "1px solid rgba(255,255,255,0.15)",
                                        background: "rgba(255,255,255,0.07)",
                                        color: "#ffffff",
                                        borderRadius: "50%",
                                        width: "34px", height: "34px",
                                        display: "flex", alignItems: "center", justifyContent: "center",
                                        cursor: "pointer",
                                    }}
                                >
                                    <span className="material-symbols-outlined" style={{ fontSize: "18px", lineHeight: 1 }}>close</span>
                                </button>
                            </div>
                        </div>

                        {/* Image area */}
                        <div
                            style={{
                                flex: 1, position: "relative",
                                display: "flex", alignItems: "center", justifyContent: "center",
                                padding: "20px", overflow: "hidden",
                            }}
                            onClick={(e) => e.stopPropagation()}
                        >
                            {isClinicalLoading && (
                                <div style={{
                                    position: "absolute", inset: 0,
                                    display: "flex", alignItems: "center", justifyContent: "center",
                                    background: "rgba(0,0,0,0.55)", zIndex: 20, pointerEvents: "none",
                                }}>
                                    <div style={{
                                        width: "52px", height: "52px", borderRadius: "50%",
                                        border: "4px solid rgba(255,255,255,0.15)",
                                        borderTopColor: "#EA7F4A",
                                        animation: "dz-spin 0.75s linear infinite",
                                    }} />
                                </div>
                            )}
                            <img
                                src={popupImage}
                                onLoad={() => setIsClinicalLoading(false)}
                                onError={() => setIsClinicalLoading(false)}
                                style={{
                                    maxWidth: "100%", maxHeight: "100%",
                                    objectFit: "contain", display: "block", borderRadius: "4px",
                                    opacity: isClinicalLoading ? 0 : 1,
                                    transition: "opacity 0.2s ease",
                                }}
                            />
                        </div>
                    </div>
                )}

            </div>



            {isPopupOpen && !dziUrl && (
                <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100vw",
                        height: "100vh",
                        backgroundColor: "rgba(0, 0, 0, 0.5)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        zIndex: 999,
                    }}
                    onClick={() => setPopupOpen(false)}
                >
                    <div className="popup_wrp"
                        style={{
                            position: "relative",
                            background: "white",
                            padding: "10px",
                            borderRadius: "10px",
                            maxWidth: "90vw",
                            maxHeight: "90vh",

                        }}
                        onClick={(e) => e.stopPropagation()}
                    >
                        {/* Close Button */}
                        <button
                            style={{
                                position: "absolute",
                                top: 10,
                                right: 10,
                                background: "white",
                                color: "#000",
                                border: "none",

                                cursor: "pointer",
                                borderRadius: "5px",
                            }}
                            onClick={() => setPopupOpen(false)}
                        >
                            <span className="material-symbols-outlined">
                                close
                            </span>
                        </button>

                        {/* Zoomable Image */}
                        <TransformWrapper ref={transformRef} initialScale={1}>
                            <div style={{ textAlign: "left", marginBottom: "10px" }}>
                                <button onClick={() => transformRef.current.zoomIn()} className="btnzoom" ><span className="material-symbols-outlined"> add </span></button>
                                <button onClick={() => transformRef.current.zoomOut()} className="btnzoom"><span className="material-symbols-outlined"> remove </span></button>
                                <button onClick={() => transformRef.current.resetTransform()} className="btnzoom"><span className="material-symbols-outlined"> refresh </span></button>
                            </div>

                            <TransformComponent>


                                {isPopupLoading && <div style={{ width: "400px", height: "400px" }}><Loader /> </div>}

                                <LazyLoadImage
                                    src={dzipopupImage + `? auto = compress, format`}
                                    effect="blur"
                                    onLoad={() => setPopupLoading(false)}
                                    style={{ width: "100%", borderRadius: "10px" }}
                                />

                            </TransformComponent>
                        </TransformWrapper>
                    </div>
                </div>
            )}

            {/* Deep Zoom Popup */}
            {isPopupOpen && dziUrl && (
                <div className="deep_zoom">
                    <div
                        style={{
                            position: "fixed",
                            top: '0',
                            left: '0',
                            right: '0',
                            bottom: '0',
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            zIndex: 999,
                            borderRadius: "18px"
                        }}
                    >
                        <div style={{
                            width: "98vw",
                            height: "98vh",
                            position: "relative",
                            backgroundColor: "black",
                            overflow: "hidden"
                        }}>
                            {/* Deep Zoom Header */}
                            <div style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                padding: "0 20px",
                                height: "52px",
                                background: "linear-gradient(135deg, #091918 0%, #215250 100%)",
                                borderBottom: "1px solid rgba(255,255,255,0.08)",
                                boxShadow: "0 2px 12px rgba(0,0,0,0.4)",
                            }}>
                                {/* Left spacer — keeps nav centred */}
                                <div style={{ width: "120px" }} />

                                {/* Prev / Counter / Next */}
                                {dziImageList.length > 1 ? (
                                    <div style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "0",
                                        background: "rgba(255,255,255,0.07)",
                                        border: "1px solid rgba(255,255,255,0.15)",
                                        borderRadius: "30px",
                                        padding: "3px",
                                    }}>
                                        {/* Prev button */}
                                        <button
                                            onClick={() => navigateDziImage(dziCurrentIndex - 1)}
                                            disabled={dziCurrentIndex === 0}
                                            title="Previous image (←)"
                                            style={{
                                                border: "none",
                                                background: dziCurrentIndex === 0 ? "transparent" : "rgba(255,255,255,0.1)",
                                                color: dziCurrentIndex === 0 ? "rgba(255,255,255,0.25)" : "#ffffff",
                                                cursor: dziCurrentIndex === 0 ? "not-allowed" : "pointer",
                                                width: "34px",
                                                height: "34px",
                                                borderRadius: "50%",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                transition: "background 0.2s",
                                                flexShrink: 0,
                                            }}
                                        >
                                            <span className="material-symbols-outlined" style={{ fontSize: "20px", lineHeight: 1 }}>chevron_left</span>
                                        </button>

                                        {/* Counter */}
                                        <span style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "4px",
                                            padding: "0 12px",
                                            fontSize: "13px",
                                            fontWeight: "600",
                                            color: "#ffffff",
                                            letterSpacing: "0.5px",
                                            userSelect: "none",
                                            whiteSpace: "nowrap",
                                        }}>
                                            <span style={{ color: "#EA7F4A", fontWeight: "700" }}>{dziCurrentIndex + 1}</span>
                                            <span style={{ color: "rgba(255,255,255,0.35)", fontSize: "11px", margin: "0 1px" }}>/</span>
                                            <span style={{ color: "rgba(255,255,255,0.6)" }}>{dziImageList.length}</span>
                                        </span>

                                        {/* Next button */}
                                        <button
                                            onClick={() => navigateDziImage(dziCurrentIndex + 1)}
                                            disabled={dziCurrentIndex === dziImageList.length - 1}
                                            title="Next image (→)"
                                            style={{
                                                border: "none",
                                                background: dziCurrentIndex === dziImageList.length - 1 ? "transparent" : "rgba(255,255,255,0.1)",
                                                color: dziCurrentIndex === dziImageList.length - 1 ? "rgba(255,255,255,0.25)" : "#ffffff",
                                                cursor: dziCurrentIndex === dziImageList.length - 1 ? "not-allowed" : "pointer",
                                                width: "34px",
                                                height: "34px",
                                                borderRadius: "50%",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                transition: "background 0.2s",
                                                flexShrink: 0,
                                            }}
                                        >
                                            <span className="material-symbols-outlined" style={{ fontSize: "20px", lineHeight: 1 }}>chevron_right</span>
                                        </button>
                                    </div>
                                ) : (
                                    <div />
                                )}

                                {/* Close button */}
                                <div style={{ width: "120px", display: "flex", justifyContent: "flex-end" }}>
                                    <button
                                        className="dz_close"
                                        onClick={closeDeepZoom}
                                        title="Close"
                                        style={{
                                            border: "1px solid rgba(255,255,255,0.15)",
                                            background: "rgba(255,255,255,0.07)",
                                            color: "#ffffff",
                                            borderRadius: "50%",
                                            width: "34px",
                                            height: "34px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            cursor: "pointer",
                                            fontWeight: "800",
                                        }}
                                    >
                                        <span className="material-symbols-outlined" style={{ fontSize: "18px", lineHeight: 1 }}>close</span>
                                    </button>
                                </div>
                            </div>

                            {/* Deep Zoom Viewer Container */}
                            <div style={{
                                height: "calc(95vh - 80px)",
                                width: "100%",
                                position: "relative"
                            }}>
                                <div
                                    id="openseadragon-viewer"
                                    ref={viewerRef}
                                    style={{
                                        height: "100%",
                                        width: "100%"
                                    }}
                                />

                                {isDziLoading && (
                                    <div style={{
                                        position: "absolute", inset: 0,
                                        display: "flex", alignItems: "center", justifyContent: "center",
                                        background: "rgba(0,0,0,0.55)", zIndex: 20, pointerEvents: "none",
                                    }}>
                                        <div style={{
                                            width: "52px", height: "52px", borderRadius: "50%",
                                            border: "4px solid rgba(255,255,255,0.15)",
                                            borderTopColor: "#EA7F4A",
                                            animation: "dz-spin 0.75s linear infinite",
                                        }} />
                                        <style>{`@keyframes dz-spin { to { transform: rotate(360deg); } }`}</style>
                                    </div>
                                )}

                                <div
                                    style={{
                                        position: "absolute",
                                        top: "50%",
                                        left: "50%",
                                        transform: "translate(-50%, -50%)",
                                        // color: "rgba(255, 255, 255, 0.25)", // softer transparency
                                        color: "grey", // softer transparency
                                        fontSize: "2vw", // medium size
                                        fontWeight: "600",
                                        textTransform: "uppercase",
                                        letterSpacing: "2px",
                                        textShadow: "1px 1px 4px rgba(0,0,0,0.6)",
                                        pointerEvents: "none",
                                        zIndex: 10,
                                        userSelect: "none"
                                    }}
                                >
                                    Copyright © 2026 DADI
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            )}


            {dziUrl && (
                <section className="viewer-section">
                    <div className="viewer-header">
                        <h2>Deep Zoom Viewer</h2>
                        <div className="viewer-controls">
                            <button className="control-button" onClick={() => window.location.reload()}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M21 2v6h-6"></path>
                                    <path d="M3 12a9 9 0 0 1 15-6.7L21 8"></path>
                                    <path d="M3 22v-6h6"></path>
                                    <path d="M21 12a9 9 0 0 1-15 6.7L3 16"></path>
                                </svg>
                                <span>Reset</span>
                            </button>
                        </div>
                    </div>

                    <div className="viewer-container">
                        <div id="openseadragon-viewer" ref={viewerRef}></div>
                        <div className="viewer-instructions">
                            <p>• Zoom with mouse wheel or pinch gesture</p>
                            <p>• Pan by clicking and dragging</p>
                            <p>• Use the navigator in the bottom-right for orientation</p>
                        </div>
                    </div>
                </section>
            )}
            <SweetAlert show={successAnswer}
                custom
                confirmBtnText="ok"
                confirmBtnBsStyle="primary"
                title={"Answer Added Successfully"}
                onConfirm={e => onConfirmAnswer()}
            >
            </SweetAlert>


            <Modal
                className="advance-search search-popup add-answer-popup"
                show={popup}
                onHide={handleClosePopup}
                backdrop="static"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Add Answer</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="input-field">
                                <label className="col-form-label">Answer</label>
                                <input
                                    className="form-control"
                                    placeholder="Enter Answer"
                                    type="text"
                                    name="answer"
                                    onChange={(e) => handleChangeAnswer(e)}
                                    value={formData?.answer}
                                />
                                {errorDisplay && (
                                    <span className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>
                                        {errorData?.answer}
                                    </span>
                                )}
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer className="flex justify-content-between px-3">
                    <button
                        className="btn cancel-modal-btn ms-2"
                        onClick={handleClosePopup}
                    >
                        Cancel
                    </button>
                    <button
                        className="create-quiz-btn border-0"
                        style={{ cursor: submitLoading ? 'not-allowed' : 'pointer', opacity: submitLoading ? 0.7 : 1 }}
                        onClick={handleSubmitAnswer}
                        disabled={submitLoading}
                    >
                        {submitLoading ? 'SUBMITTING...' : 'SUBMIT'}
                    </button>
                </Modal.Footer>
            </Modal>


            <ToastContainer
                id="toastContainer"
                position="bottom-center"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover={false}
                theme="light"
            />



            <SweetAlert show={deleteImageSuccess}
                custom
                confirmBtnText="ok"
                confirmBtnBsStyle="primary"
                title={"Deleted Successfully"}
                onConfirm={e => ondeleteImageConfirm()}
            >
            </SweetAlert>

            <SweetAlert show={success}
                custom
                confirmBtnText="ok"
                confirmBtnBsStyle="primary"
                title={successMsg}
                onConfirm={e => onConfirm()}
            >
            </SweetAlert>

            <SweetAlert show={UpdateSuccess}
                custom
                confirmBtnText="ok"
                confirmBtnBsStyle="primary"
                title={successMsg}
                onConfirm={e => onUpdateConfirm()}
            >
            </SweetAlert>

            <SweetAlert show={deleteImage}
                warning
                showCancel
                confirmBtnText="Yes"
                cancelBtnText="Cancel"
                confirmBtnBsStyle="danger"
                cancelBtnBsStyle="default"
                title="Are you sure you want to delete?"
                focusCancelBtn
                onConfirm={e => imageFileDelete(e)}
                onCancel={e => onDelImageCancel(e)}
            >
            </SweetAlert>

            <SweetAlert show={deleteMultipleImages}
                warning
                showCancel
                confirmBtnText="Yes, Delete All"
                cancelBtnText="Cancel"
                confirmBtnBsStyle="danger"
                cancelBtnBsStyle="default"
                title={`Delete ${selectedFiles.length} selected file${selectedFiles.length !== 1 ? 's' : ''}?`}
                focusCancelBtn
                onConfirm={executeMultiDelete}
                onCancel={cancelMultiDelete}
            >
            </SweetAlert>

            <SweetAlert show={deleteMultipleSuccess}
                custom
                confirmBtnText="Ok"
                confirmBtnBsStyle="primary"
                title={"Files Deleted Successfully"}
                onConfirm={confirmMultiDeleteSuccess}
            >
            </SweetAlert>
            <SweetAlert show={iscaseExisted}
                warning
                confirmBtnText="Ok"
                confirmBtnBsStyle="danger"
                cancelBtnBsStyle="default"
                title="Case number already exists."
                focusCancelBtn
                onConfirm={e => setIscaseExist(false)}
            >
            </SweetAlert>
            <SweetAlert show={alertPopup}
                warning
                confirmBtnText="Ok"
                confirmBtnBsStyle="danger"
                cancelBtnBsStyle="default"
                title="Maximum 10 files allowed"
                focusCancelBtn
                onConfirm={e => setAlertPopup(false)}
            >

            </SweetAlert>
            <SweetAlert show={alertPopup2}
                warning
                confirmBtnText="Ok"
                confirmBtnBsStyle="danger"
                cancelBtnBsStyle="default"
                title="Maximum 20 files allowed"
                focusCancelBtn
                onConfirm={e => setAlertPopup2(false)}
            >
            </SweetAlert>
            <SweetAlert
                show={uploadImg}
                showConfirm={false}
                title=""
            //  onConfirm={() => setAlert(null)}
            >
                <div className="d-flex flex-column align-items-center">
                    <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">File Uploading...</span>
                    </div>
                    <p className="mt-3">File is Uploading...</p>
                </div>
            </SweetAlert>

            <SweetAlert show={fileSizeError}
                warning
                confirmBtnText="ok"
                confirmBtnBsStyle="danger"
                title={fileSizeErrorMsg}
                onConfirm={e => setFileSizeError(false)}
            >
            </SweetAlert>
            {/* {editUser?.files && <FileUploadChecker files={editUser.files} />} */}

            {/* Share Image Modal */}
            <Modal show={showShareModal} onHide={() => setShowShareModal(false)} centered enforceFocus={false} dialogClassName="share-modal-narrow">
                <Modal.Header closeButton closeVariant="white" style={{ backgroundColor: "#1E222B", borderBottom: "1px solid #333" }}>
                    <Modal.Title style={{ color: "#fff", fontSize: "16px", display: "flex", alignItems: "center", gap: "8px" }}>
                        <span className="material-symbols-outlined" style={{ color: "#F2A341", fontSize: "22px" }}>share</span>
                        Share Histology Image
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ padding: "24px" }}>
                    {shareUrl ? (
                        <div>
                            <div className="d-flex align-items-center gap-2 mb-3 p-3" style={{ background: "rgba(34,197,94,0.08)", borderRadius: "8px", border: "1px solid rgba(34,197,94,0.3)" }}>
                                <span className="material-symbols-outlined" style={{ color: "#22c55e", fontSize: "20px" }}>check_circle</span>
                                <div>
                                    <p className="mb-0" style={{ fontWeight: 600, fontSize: "14px", color: "#166534" }}>Share link is active!</p>
                                    {shareExpiresAt && (
                                        <p className="mb-0" style={{ fontSize: "12px", color: "#555" }}>
                                            Expires: {new Date(shareExpiresAt).toLocaleString()}
                                        </p>
                                    )}
                                </div>
                            </div>
                            <p className="text-muted mb-2" style={{ fontSize: "13px" }}>Share link:</p>
                            <input
                                type="text"
                                className="form-control mb-3"
                                value={shareUrl}
                                readOnly
                                style={{ fontSize: "13px", backgroundColor: "#f8f9fa" }}
                            />
                            <div className="d-flex gap-2">
                                <button
                                    className="btn w-50"
                                    style={{ backgroundColor: "#1E222B", color: "#fff", border: "none", borderRadius: "6px", fontWeight: 600, fontSize: "14px", display: "flex", alignItems: "center", justifyContent: "center", gap: "6px" }}
                                    onClick={handleCopyShareUrl}
                                >
                                    <span className="material-symbols-outlined" style={{ fontSize: "18px" }}>content_copy</span>
                                    Copy Link
                                </button>
                                <button
                                    className="btn w-50"
                                    style={{ backgroundColor: "#25D366", color: "#fff", border: "none", borderRadius: "6px", fontWeight: 600, fontSize: "14px", display: "flex", alignItems: "center", justifyContent: "center", gap: "6px" }}
                                    onClick={handleWhatsAppShare}
                                >
                                    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>
                                    WhatsApp
                                </button>
                            </div>
                        </div>
                    ) : (
                        <div>
                            {shareFile && (
                                <div className="d-flex align-items-center gap-2 mb-4 p-3" style={{ background: "#f8f9fa", borderRadius: "8px", border: "1px solid #e9ecef" }}>
                                    <span className="material-symbols-outlined" style={{ color: "#F2A341", fontSize: "20px" }}>image</span>
                                    <span style={{ fontSize: "13px", color: "#555", fontWeight: 500 }}>{shareFile?.originalFilename || shareFile?.filename || "Histology Image"}</span>
                                </div>
                            )}
                            <p className="mb-2" style={{ fontWeight: 600, fontSize: "14px", color: "#1E222B" }}>Set expiry date &amp; time</p>
                            <p className="text-muted mb-3" style={{ fontSize: "13px" }}>This link will automatically expire at the selected date and time.</p>
                            <div className="mb-3">
                                <label className="form-label" style={{ fontSize: "13px", fontWeight: 600, color: "#444" }}>Expires On</label>
                                <ThemeProvider theme={orangeTheme}>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DateTimePicker
                                            value={shareExpiryAt}
                                            onChange={(newValue) => setShareExpiryAt(newValue)}
                                            disablePast
                                            format="DD/MM/YYYY hh:mm A"
                                            slotProps={{
                                                textField: {
                                                    fullWidth: true,
                                                    size: "small",
                                                    placeholder: "Select date and time",
                                                },
                                            }}
                                        />
                                    </LocalizationProvider>
                                </ThemeProvider>
                                <div className="d-flex flex-wrap gap-2 mt-2">
                                    {[{ label: "6 hours", h: 6 }, { label: "12 hours", h: 12 }, { label: "1 day", h: 24 }, { label: "3 days", h: 72 }, { label: "1 week", h: 168 }].map((preset) => {
                                        const isActive = shareExpiryAt && shareExpiryAt.isValid() && Math.abs(shareExpiryAt.diff(dayjs().add(preset.h, 'hour'), 'minute')) < 1;
                                        return (
                                            <button
                                                key={preset.h}
                                                type="button"
                                                onClick={() => setShareExpiryAt(dayjs().add(preset.h, 'hour'))}
                                                style={{
                                                    fontSize: "12px", fontWeight: 600, padding: "4px 12px", borderRadius: "20px", cursor: "pointer",
                                                    border: isActive ? "1.5px solid #F2A341" : "1px solid #ddd",
                                                    background: isActive ? "#fff3e0" : "#fff",
                                                    color: isActive ? "#d97706" : "#555",
                                                }}
                                            >
                                                {preset.label}
                                            </button>
                                        );
                                    })}
                                </div>
                            </div>
                            {isShareExpiryValid && (
                                <div style={{ display: "flex", alignItems: "center", gap: "10px", background: "linear-gradient(135deg, #fff8ee 0%, #fff3e0 100%)", border: "1.5px solid #F2A341", borderRadius: "8px", padding: "10px 14px", marginBottom: "14px" }}>
                                    <span className="material-symbols-outlined" style={{ fontSize: "22px", color: "#F2A341", flexShrink: 0 }}>schedule</span>
                                    <div>
                                        <div style={{ fontSize: "11px", fontWeight: 600, color: "#999", textTransform: "uppercase", letterSpacing: "0.5px", lineHeight: 1 }}>Link expires</div>
                                        <div style={{ fontSize: "15px", fontWeight: 700, color: "#d97706", marginTop: "2px" }}>
                                            {shareExpiryAt.format("DD MMM YYYY, hh:mm A")}
                                        </div>
                                        <div style={{ fontSize: "12px", fontWeight: 600, color: "#b45309", marginTop: "1px" }}>
                                            {getShareExpiryCountdown()}
                                        </div>
                                    </div>
                                </div>
                            )}
                            <button
                                className="btn w-100 mt-1"
                                style={{
                                    backgroundColor: "#F2A341",
                                    color: "#fff",
                                    border: "none", borderRadius: "6px", fontWeight: 700, fontSize: "14px", padding: "10px",
                                    cursor: isShareExpiryValid && !shareGenerating ? "pointer" : "not-allowed",
                                    display: "flex", alignItems: "center", justifyContent: "center", gap: "8px",
                                    opacity: isShareExpiryValid && !shareGenerating ? 1 : 0.45,
                                }}
                                disabled={!isShareExpiryValid || shareGenerating}
                                onClick={handleGenerateShareUrl}
                            >
                                {shareGenerating ? (
                                    <>
                                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                        Generating...
                                    </>
                                ) : (
                                    <>
                                        <span className="material-symbols-outlined" style={{ fontSize: "18px" }}>link</span>
                                        Generate Share Link
                                    </>
                                )}
                            </button>
                        </div>
                    )}
                </Modal.Body>
            </Modal>

        </>
    );
};

export default EditTest;